// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Lato&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #2196F3;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}

.new-button {
        display: inline-block;
    padding: 10px 10px;
    cursor: pointer;
    border: 1px solid #D9D9D9;
    font-size: 14px;
    color: #595D6E;
}
.button-wrap input[type="file"] {
  position: absolute;
  z-index: -1;
  top: 6px;
  left: 0;
  font-size: 15px;
  color: rgb(153,153,153);
}
.button-wrap {
  position: relative;display: flex;
}
.button-wrap button {
    margin-left: 10px;
}

.new-csvbutton {
        display: inline-block;
    padding: 10px 10px;
    cursor: pointer;
    border: 1px solid #D9D9D9;
    font-size: 14px;
    color: #595D6E;
    background: none;
}




html, body {
    margin: 0;
    padding: 0;
    height: 100%;
    min-height: 100%;
}

* {
    box-sizing: border-box;
}

body {
    background-color: #f2f3f8;
    margin: 0;
    padding: 0px;
    font-family: 'Lato', sans-serif;
    font-size: 14px;
    color: #464242;
}

::-webkit-scrollbar {
    width: 6px;
    height: 4px;
}

/* Track */

::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 8px;
}

/* Handle */

::-webkit-scrollbar-thumb {
    background: #6399DD;
    border-radius: 8px;
    -webkit-transition: all .3s;
    transition: all .3s;
}

/* Handle on hover */

::-webkit-scrollbar-thumb:hover {
    background: #6399DD;
}

p, h1, h2, h3, h4, h5, h6 {
    margin: 0px;
}

ul {
    list-style-type: none;
    padding: 0px;
    margin: 0px;
}

label {
    display: block;
}

.dn {
    display: none;
}

.db {
    display: block;
}

button:focus {
    outline: 0;
}

.text-center {
    text-align: center;
}

.text-left {
    text-align: left;
}

.text-right {
    text-align: right;
}

.pd-20 {
    padding: 20px;
}

.bg-grey {
    background-color: #f2f3f8;
}

.pl-10 {
    padding-left: 10px;
}

.pl-20 {
    padding-left: 20px;
}

.mt-5 {
    margin-top: 5px;
}

.m-0 {
    margin: 0;
}

.mt-10 {
    margin-top: 10px;
}

.mt-15 {
    margin-top: 15px;
}
.ml-5 {
    margin-left: 5px;
}
.ml-10 {
    margin-left: 10px;
}
.ml-20 {
    margin-left: 20px;
}
.ml-30 {
    margin-left: 30px;
}


.mr-10 {
    margin-right: 10px;
}

.mr-15 {
    margin-right: 15px;
}

.ml-15 {
    margin-left: 15px;
}

.mt-15 {
    margin-top: 15px;
}

.mt-20 {
    margin-top: 20px;
}

.mb-5 {
    margin-bottom: 5px;
}

.mb-10 {
    margin-bottom: 10px;
}

.mb-15 {
    margin-bottom: 15px;
}

.mb-20 {
    margin-bottom: 20px;
}

.mb-30 {
    margin-bottom: 30px;
}

.mr-20 {
    margin-right: 20px;
}

.wd-25 {
    width: 25%;
}

.wd-20 {
    width: 20%;
}

.wd-30 {
    width: 30%;
}

.wd-35 {
    width: 35%;
}

.wd-33 {
    width: 33.333%;
}

.wd-40 {
    width: 40%;
}

.wd-50 {
    width: 50%;
}
.wd-60 {
    width: 60%;
}
.wd-65 {
    width: 65%;
}

.wd-66 {
    width: 66.666%;
}

.wd-75 {
    width: 75%;
}

.wd-70 {
    width: 70%;
}

.wd-100 {
    width: 100%;
}
.vh15{
    height: 15vh;
}
.promize-badge {
    padding: 4px 20px;
    border-radius: 13px;
    display: inline-block;
}

.promize-badge.badge-primary {
    background-color: #011838;
    color: #fff;
}

.promize-badge.badge-default {
    background-color: #D6D9E4;
    color: #3B3B3B;
}

.promize-badge-group li:not(:last-child) {
    margin-right: 10px;
}

input:disabled, select:disabled {
    opacity: 0.4;
}

.promize-toggle {
    display: flex;
    align-items: center;
}

.promize-toggle>label:first-child {
    margin-right: 10px;
    color: #4c4646;
    font-size: 13px;
    font-family: "Lato";
}

.promize-toggle>label:first-child:empty {
    display: none;
}

.promize-card-action.promize-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
}

.toggle-aa {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.toggle-aa .tgl-btn {
    margin-top: 20px;
}

.promize-left-sizebar {
    width: 80px;
    position: fixed;
    height: 100%;
    background-color: #011838;
    z-index: 9;
    transition: width .3s;
}

.promize-page-title-wrapper {
    border-bottom: 1px solid #ddd;
    padding-bottom: 5px;
    margin-bottom: 20px;
}

.promize-page-title {
    font-weight: normal;
    font-size: 24px;
}

.promize-left-sizebar:hover {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
    width: 190px;
}

.promize-card {
    background-color: #fff;
    border-radius: 0;
    box-shadow: 0 0 13px 0 rgba(82, 63, 105, .05);
}

.promize-container-fuild {
    padding: 20px;
}

.promize-logo-lg img {
    width: 200px;
}

.promize-logo {
    text-align: center;
    margin: 20px 0px;
    width: 100%;
}

.promize-logo img {
    max-width: 40px;
}

.promize-menu-items {
    list-style: none;
    padding: 0;
    margin: 0;
    margin-left: 10px;
    overflow: hidden;
}

.promize-form-group {
    position: relative;
    margin-bottom: 25px;
}

.promize-action-list .rule-action-item .wd-30:nth-child(4) .promize-form-group {
    width: 163px;
}

.promize-form-control {
    display: block;
    width: 100%;
    padding: 5px 10px;
    height: 40px;
    font-size: 14px;
    font-family: "Lato";
    line-height: 34px;
    color: #595D6E;
    background-color: #fff;
    background-image: none;
    border: 0;
    border: 1px solid #D9D9D9;
    border-radius: 3px;
    box-shadow: none;
    transition: border-color ease-in-out .15s;
}

textarea.promize-form-control {
    height: auto;
    width: 100% !important;
}

.promize-form-error {
    font-size: 11px;
    position: absolute;
    bottom: -15px;
    color: #FF5722;
}
.promize-form-info {
    font-size: 11px;
    position: absolute;
    bottom: -17px;
    left: 0;
}
.promize-form-info>i {
    margin-right: 5px;
}
.promize-form-control:focus {
    outline: 0;
    border-color: #2F89F9;
}

.promize-form-group .promize-form-control-label {
    margin-bottom: 6px;
    color: #4c4646;
    font-size: 13px;
    font-family: "Lato";
}

.promize-form-addon {
    display: flex;
    align-items: flex-end;
}

.promize-picker {
    width: 50px;
    height: 40px;
    border: 1px solid #d9d9d9;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.promize-picker img {
    max-width: 20px;
}

.sketch-picker {
    width: 170px !important;
}

.sketch-picker>div:first-child {
    padding-bottom: 45% !important;
}

.sketch-picker>div:last-child {
    display: none !important;
}

.promize-picker-control {
    width: 100%;
}

.promize-picker-control .promize-form-control {
    border-right: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.promize-menu-items>li {
    margin-bottom: 8px;
}

.promize-sizebar-item a {
    text-decoration: none;
    color: #778088;
    padding: 20px;
    padding-left: 10px;
    width: 70px;
    height: 60px;
    border-left: 5px solid transparent;
    border-radius: 4px 0px 0px 4px;
    padding-right: 0px;
    display: flex;
    align-items: center;
    transition: all .3s;
}

.promize-left-sizebar:hover .promize-sizebar-item a {
    width: 180px;
}
.promize-left-sizebar:hover .promize-sizebar-item a:hover {
    background-color: rgba(255, 255, 255, 0.1);
    color: #a5adb5;
}
.promize-sidebar-links.active {
    border-radius: 4px 0px 0px 4px;
    background: linear-gradient(to right, #162a45 0%, #011838 100%);
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.39);
    border-left: 5px solid #2F89F9;
    color: #fff;
}

.promize-sizebar-item a i {
    font-size: 18px;
    margin: 0px 8px;
}

.promize-sizebar-item a>div {
    display: flex;
    align-items: center;
}

.promize-sizebar-item a>div>span {
    opacity: 0;
    transition: opacity .3s;
    margin-left: 12px;
    white-space: nowrap;
}

.promize-left-sizebar:hover .promize-sizebar-item a>div>span {
    opacity: 1;
}

.promize-sizebar-item.active a i {
    color: #fff;
}

.promize-main-wrapper {
    display: flex;
    flex-flow: row;
}

.promize-page-wrapper {
    width: 100%;
    margin-left: 80px;
}

.promize-table {
    width: 100%;
    border-spacing: 0;
    border-collapse: collapse;
}

.promize-table thead tr th, .promize-table tbody tr td {
    padding: 10px 10px;
    font-size: 14px;
    font-family: Lato;
}

.promize-table thead tr {
    border-bottom: 0;
    height: 40px;
    color: #fff;
    font-size: 18px;
}

.promize-table thead tr th {
    background-color: #EBEDF2;
    font-weight: bold;
    font-size: 14px;
    text-align: left;
    color: #434863;
    padding: 16px 10px;
}

.promize-table tbody {
    border-bottom: 1px solid #eeeeee;
}

.promize-table tbody tr {
    border-bottom: 1px solid #eeeeee;
    height: 35px;
}

.promize-table tbody tr td {
    font-weight: 500;
    font-size: 14px;
    text-align: left;
    color: #464242;
    font-weight: 400;
    transition: all .1s;
}

.promize-table tbody tr td:not(.option-code):first-letter {
    text-transform: uppercase;
}

.promize-table tbody tr:nth-child(even) td {
    background-color: #f9f9f9;
}

.table-hover tbody tr:hover td {
    background-color: rgba(1, 24, 56, 0.04);
}

.table-action thead tr th:last-child, .table-action thead tr th:nth-last-child(2) {
    width: 160px;
}

.promize-table.table-action thead tr th:last-child, .promize-table.table-action tbody tr td:last-child {
    text-align: center;
}

.promize-table th.sorting::after {
    content: "\\f0dc";
    font-family: 'Font Awesome 5 Free';
    margin-left: 8px;
    color: #abafc2;
}

.promize-table th.sorting-asec::after {
    content: "\\f0de";
    font-family: 'Font Awesome 5 Free';
    margin-left: 8px;
    color: #5584c7;
    font-size: 16px;
}

.promize-table th.sorting-desc::after {
    content: "\\f0dd";
    font-family: 'Font Awesome 5 Free';
    margin-left: 8px;
    color: #5584c7;
    font-size: 16px;
}

.promize-table.table-options thead tr th {
    background-color: transparent;
}

.promize-table.table-options tbody tr td {
    background-color: #fff;
}

.promize-table.table-options {
    border-spacing: 0px 12px;
    border-collapse: separate;
    margin-top: -12px;
}

.table-options.table-action thead tr th:last-child {
    width: 120px;
}

.promize-table.table-options thead tr th {
    padding: 5px 10px;
}

.promize-table.table-options tbody tr {
    overflow: hidden;
    border-radius: 5px;
    border: 0;
    box-shadow: 0 0 13px rgba(82, 63, 105, 0.10);
}

.promize-table.table-options tbody tr td:first-child {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
}

.promize-table.table-options tbody tr td:last-child {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
}

.promize-card-header {
    padding: 0px 20px;
    display: flex;
    justify-content: space-between;
    position: relative;
}
.promize-attr-dup-text {
    position: absolute;
    top: 4px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    padding: 5px 10px;
    background-color: rgba(0, 173, 29, 0.1);
    color: #007313;
    border-radius: 5px;
    font-size: 14px;
}
.promize-card-innerheader {
    padding: 0px;
    border-bottom: 1px solid #d9d9d9;
    margin-bottom: 20px;
}

.promize-card-title h3 {
    margin-top: 16px;
}

.promize-card-title {
    display: flex;
    align-items: baseline;
    justify-content: center;
    flex-wrap: wrap;
    flex-direction: column;
}

.promize-card-innerheader h3 {
    margin-top: 0;
}

.promize-card-subtitle {
    font-size: 13px;
}

.promize-title-subtitle {
    font-size: 12px;
    color: #9e9e9e;
}

.promize-card-title h3 span {
    font-size: 16px;
    text-transform: capitalize;
    color: #011838;
}

.promize-card-innertitle h3 span {
    font-size: 18px;
    text-transform: capitalize;
    color: #011838;
}

.promize-card-body {
    padding: 20px;
    min-height: 15vh;
}

.promize-footer-actions {
    text-align: right;
    padding: 0px 20px 20px;
}

.promize-card-action {
    width: 40%;
    max-width: 400px;
    display: flex;
    margin-top: 20px;
    justify-content: space-between;
}

.promize-sm-card-action {
    width: 30%;
    max-width: 350px;
    display: flex;
    margin-top: 10px;
    justify-content: space-between;
}

.search-container+.btn {
    margin-left: 10px;
    width: 160px;
}

.promize-card-innerheader .promize-card-action {
    margin: 5px 0px;
}

.search-container {
    position: relative;
    width: 100%;
}

.search-container i {
    position: absolute;
    top: 14px;
    color: #d9d9d9;
    left: 12px;
}

.search-container .promize-form-control {
    padding-left: 40px;
    font-weight: normal;
}
.promize-product-add {
    width: unset;
    max-width: unset;
}

.promize-product-add .btn {
    width: 150px;
}

.promize-product-add .search-container {
    max-width: 240px;
}
.df {
    display: flex;
}

.df-wrap {
    display: flex;
    flex-wrap: wrap;
}

.df-end {
    justify-content: flex-end;
}

.df-flow {
    display: flex;
    flex-flow: row;
    flex-wrap: wrap
}

.df-sp-btwn {
    display: flex;
    justify-content: space-between;
}

.df-sp-around {
    display: flex;
    justify-content: space-around;
}

.df-al-center {
    display: flex;
    align-items: center;
}

.df-js-center {
    display: flex;
    justify-content: center;
}

.df-al-cen {
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn {
    font-family: 'Lato', sans-serif;
    font-size: 15px;
    text-transform: capitalize;
    border: 0;
    box-shadow: none;
    height: 40px;
    padding: 10px 10px;
    min-width: 90px;
    box-shadow: none;
    border-radius: 2px;
    cursor: pointer;
    display: inline-block;
    background-color: transparent;
    border: 1px solid transparent;
    text-align: center;
    text-decoration: none;
    transition: all .3s;
}

.txt-captls {
    text-transform: capitalize;
}

.btn:focus {
    outline: 0;
}

.btn-promize-primary {
    border: 1px solid #2F89F9;
    background-color: #2F89F9;
    color: #fff;
}
.btn-promize-primary+.btn-promize-primary{
    margin-left: 10px;
}
.btn-promize-secondary {
    background-color: #fff;
    color: #6b6e82;
    border: 1px solid #6b6e82;
    margin-right: 10px;
}

.btn-promize-primary:hover{
    background-color: #034394;
    border: 1px solid #034394;
}
.btn-promize-secondary:hover {
    color: #fff;
    border: 1px solid #6b6e82;
    background-color: #6b6e82;
}

.btn-links {
    font-size: 13px;
    color: #2F89F9;
}

.btn-tbl {
    display: inline-block;
    font-size: 14px;
    border: 0;
    box-shadow: none;
    height: 36px;
    width: 36px;
    line-height: 36px;
    padding: 0px 5px;
    border: 0;
    background-color: #ffffffd9;
    box-shadow: none;
    cursor: pointer;
    color: #777b92;
    border-radius: 5px;
    transition: all .3s;
    border: 1px solid #eaeaea;
}

.btn-tbl+.btn-tbl {
    margin-left: 15px;
}

.btn-tbl:hover {
    box-shadow: 0 4px 10px rgba(1, 24, 56, 0.25);
}

.btn-links:hover {
    background-color: #eff2fe;
}

.promize-pagination ul {
    display: flex;
}

.promize-pagination ul li:not(:last-child) {
    margin-right: 8px;
}

.promize-pagination ul li button {
    color: #5660a2;
    float: left;
    text-decoration: none;
    height: 32px;
    width: 34px;
    padding-bottom: 1px;
    font-size: 13px;
    box-shadow: none;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2px;
    transition: .3s;
    cursor: pointer;
}

.promize-pagination ul li button.active {
    background-color: #2f89f9;
    color: white;
}

.promize-pagination ul li:first-child button, .promize-pagination ul li:last-child button, .promize-pagination ul li:nth-child(2) button, .promize-pagination ul li:nth-last-child(2) button {
    background-color: #ebedf2;
}

.promize-pagination ul li button:hover {
    background-color: #3b7cf8;
    color: #fff;
}

.promize-pagination ul li.disabled button {
    opacity: .4;
    cursor: not-allowed;
    pointer-events: none;
}

.table-footer-action {
    display: flex;
    justify-content: space-between;
    margin: 20px 0px 5px;
}

.promize-entries {
    display: flex;
    align-items: center;
}

.promize-entries p {
    color: #6a6e84;
    font-size: 12px;
}

.df-end .check-mainbox {
    display: flex;
    justify-content: center;
    align-items: center;
}

.select-control {
    background-color: rgba(93, 120, 255, 0.1);
    border: 0;
    box-shadow: none;
    border-radius: 0;
    color: #2F89F9;
    font-weight: bold;
    width: 70px;
}

.promize-entries .select-control {
    height: 30px;
}

.promize-info-text {
    font-size: 13px;
    color: #999;
}

.promize-info-text a {
    color: #2F89F9;
    text-decoration: underline;
}

.tgl {
    display: none;
}

.tgl+.tgl-btn {
    outline: 0;
    display: block;
    width: 50px;
    height: 26px;
    position: relative;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
}

.tgl+.tgl-btn:hover {
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.36);
}

.tgl+.tgl-btn:after, .tgl+.tgl-btn:before {
    position: relative;
    display: block;
    content: "";
    width: 20px;
    height: 20px;
}

.tgl+.tgl-btn:after {
    left: 1px;
}

.tgl+.tgl-btn:before {
    display: none;
}

.tgl:checked+.tgl-btn:after {
    left: calc(50% + 1px);
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
}

.tgl-light+.tgl-btn {
    background: #9E9E9E;
    border-radius: 2em;
    padding: 3px;
    transition: all .4s ease;
}

.tgl-light+.tgl-btn:after {
    border-radius: 50%;
    background: #fff;
    transition: all .2s ease;
}

.tgl-light:checked+.tgl-btn {
    background: #3c9ece;
    background: linear-gradient(45deg, #2f89f9, rgba(47, 137, 249, 0.7));
}

.multi_select_option {
    padding: 10px
}

.multi_select_option:hover {
    background-color: #dee7fe
}

.multi_select_option .multi_select_sub_label {
    font-size: 10px;
}

.promize-customizer {
    width: 100%;
    background-color: #fff;
    height: 100vh;
    text-align: left;
}

.promize-inncustomizer {
    padding: 30px;
}

.promize-buttons {
    text-align: right;
}

.promize-attr-title {
    color: #011838;
    font-size: 15px;
    margin-bottom: 15px;
}

label sup {
    color: #F44336;
    font-size: 13px;
    height: 5px;
    line-height: 5px;
}

.promize.add-field {
    margin: 0;
    display: inline-block;
    border-radius: 5px;
    border: 2px solid #2e88f9;
    height: 155px;
    margin-left: 20px;
    padding: 10px;
    box-shadow: 4px 3px 15px 3px rgba(145, 145, 145, 0.89);
    margin-left: 20px;
    margin-top: 20px;
}

.edit i.fa.fa-pencil-square-o {
    border: 1px solid #27c527;
    padding: 10px;
    margin: 10px;
    color: #27c527;
    border-radius: 2px;
}

.edit i.fa.fa-trash {
    color: red;
    border: 1px solid red;
    padding: 10px;
    border-radius: 2px;
}

.promize-uplaod {
    text-align: center;
}

.promize-sticky-20 {
    position: sticky;
    top: 20px;
    align-self: flex-start;
}

.promize-set-position {
    /* padding-right: 20px; */
}

.promize-set-position>button {
    background-color: transparent;
    border: none;
    box-shadow: none;
    font-size: 16px;
    text-decoration: underline;
}

.promize-widget .promize-widget {
    border: 1px solid #E8E8E8;
}

.promize-widget .promize-widget.promize-subtab {
    border-left: 5px solid #2e89f9;
}

.promize-modal-cover, .promize-modal-cover-delete-popup, .promize-modal-cover-tab-selection, .promize-modal-cover-set-postion {
    position: fixed;
    background-color: rgba(0, 0, 0, 0.6);
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 9;
    overflow: auto;
}

.promize-modal.modal-sm, .promize-modal-cover-delete-popup.modal-sm, .promize-modal-cover-tab-selection.modal-sm, .promize-modal-cover-set-postion.modal-sm {
    position: relative;
    max-width: 35%;
    background-color: #fff;
    padding: 0;
    left: 0;
    right: 0;
    border-radius: 5px;
    overflow: hidden;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
    transform: translate(0, 0);
    margin: 30px auto;
}

.promize-modal.modal-lg {
    position: relative;
    max-width: 70%;
    background-color: #fff;
    padding: 0;
    left: 0;
    top: 0;
    right: 0;
    border-radius: 5px;
    overflow: hidden;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
    transform: translate(0, 0);
    margin: 30px auto;
}

.promize-modal.modal-md {
    position: relative;
    max-width: 50%;
    background-color: #fff;
    padding: 0;
    left: 0;
    top: 0;
    right: 0;
    border-radius: 5px;
    overflow: hidden;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
    transform: translate(0, 0);
    margin: 30px auto;
}

.promize-modal-header {
    padding: 14px 0px 14px 20px;
    background-color: #F7F7F7;
    border-bottom: 1px solid #d9d9d9;
}

.modal-close {
    position: absolute;
    right: 5px;
    top: 5px;
    border: 0;
    padding: 10px 15px;
    background-color: transparent;
    font-size: 15px;
    color: #3C3C3C;
    cursor: pointer;
}

.promize-modal-body {
    padding: 15px;
    background-color: #fff;
}

.promize-modal-footer {
    background-color: #fff;
    padding: 15px;
    padding-top: 0px;
}
.promize-modal-footer .previous{
    background: white;
    border: 1px solid black;
    height: 40px;
    margin-right: 1rem;
    padding: 0 1rem;
    cursor: pointer;
}

.promize-modal-footer .next{
    background: white;
    border: 1px solid black;
    height: 40px;
    margin-right: 1rem;
    padding: 0 1rem;
    cursor: pointer;
}
.modal-title {
    font-size: 18px;
    color: #464457;
    font-weight: normal;
    font-family: "Lato";
}

.btn-modal-close {
    float: right;
    margin-top: -25px;
    margin-right: 10px;
    padding: 5px 10px;
    font-size: 15px;
    border: none;
    box-shadow: none;
    background-color: transparent;
    cursor: pointer;
    color: #464457;
}
.promize-link-thumb{
    max-width: 40px;
    max-height: 26px;
}
.promize-upload-header {
    position: relative;
    margin-bottom: 8px;
}

.promize-upload {
    background-color: #fff;
}

.promize-upload:focus {
    outline: 0;
}

.promize-upload-title {
    font-size: 13px;
    font-family: "Lato";
    font-weight: normal;
    color: #4c4646;
}

.promize-upload-button {
    font-family: "Lato";
    font-size: 13px;
    padding: 0px;
    color: #2f89f9;
    position: relative;
    cursor: pointer;
}

.promize-content-before-upload>img {
    max-width: 90px;
    max-height: 90px;
}

.promize-prdt-section-list {
    display: flex;
    max-width: calc(100% - 130px);
    overflow: auto hidden;
}

.promize-prdt-section-container {
    position: relative;
    border-bottom: 1px solid #D0D0D0;
}
.promize-prdt-section-container .pormize-abs-rght .btn-links:hover{
    background-color: #e4e4e4;
}
.promize-content-before-upload {
    text-align: center;
}

.promize-upload-content {
    padding: 10px;
    border: 1px solid #d9d9d9;
    border-radius: 5px;
    min-height: 165px;
    transition: all .3s;
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}
.promize-upload-content.promize-multi-upload-cover {
    align-items: flex-start;
    justify-content: flex-start;
}
.promize-upload-sm .promize-upload-content {
    height: 80px;
    min-height: 80px;
    display: flex;
    border-style: dashed;
    border-color: #9e9e9e;
    align-items: center;
    justify-content: center;
    padding: 5px;
    color: #716f6f;
}

.promize-upload-sm .promize-upload-content p {
    margin-top: 6px;
}

.promize-upload-sm .promize-content-after-upload img {
    max-width: 60px;
    max-height: 60px;
}

.custom-upload-product img {
    max-width: 200px;
    margin-bottom: 10px;
}

.custom-upload-product {
    position: absolute;
    top: 0px;
    right: 0px;
}

.custom-upload-product input {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 100%;
    width: 100%;
    opacity: 0;
    cursor: pointer;
}
.promize-upload-content.promize-multi-upload-cover .promize-content-before-upload{
    align-items: center;
    width: 100%;
    margin-top: 20px;
}
.promize-upload-content .react-sweet-progress{
    display: flex;
    align-items: center;
    justify-content: center;
    width: calc(100% + 2px);
    position: absolute;
    height: calc(100% + 2px);
    top: -1px;
    left: -1px;
    background-color: rgba(255, 255, 255, 0.8);
    padding: 20px;
    border-radius: 4px;
}
.promize-upload-content .react-sweet-progress-line {
    width: 100%;
    border-radius: 6px;
    height: 6px;
    background-color: rgb(231, 230, 230);
    vertical-align: middle;
}
.promize-upload-content .react-sweet-progress-line-inner {
    position: relative;
    min-height: 6px;
    border-radius: 6px;
    transition: width 0.3s ease;
}
.promize-upload-content .react-sweet-progress-symbol
{
    display: none;
}
.promize-display-items>label:not(:last-child) {
    margin-right: 10px;
}

.promize-display-items {
    display: flex;
    flex-wrap: nowrap;
}

.promize-display-set {
    padding-left: 30px;
    margin-left: 30px;
    border-left: 1px dashed #9e9e9e;
}

.promize-display-set .promize-form-group {
    margin-bottom: 0;
    margin-top: 10px;
}
.promize-display-set .check-mainbox
{
    margin-top: 10px;
}
.promize-display-set .check-mainbox .toggle-aa .tgl-btn{
    margin-top: 15px;
}
.promize-dragable-tab-container>.promize-widget {
    cursor: grab;
    transition: all .3s;
}

.promize-dragable-tab-container>.promize-widget:hover {
    box-shadow: 0 5px 10px #01183726;
}

.tab-drag-empty {
    height: 50px;
    border: 1px dashed #2f89f9;
    margin-bottom: 20px;
}

.promize-dragable-list>li {
    cursor: grab;
}

.promize-sticky-20 .promize-dragable-container {
    max-height: 60vh;
    overflow-y: auto;
    padding-right: 5px;
}

.dragable-items {
    border: 1px solid #e8e8e8;
    border-radius: 3px;
    overflow: hidden;
    transition: all .3s;
}

.option-name {
    color: #464242;
    position: relative;
    text-transform: capitalize;
    padding-top: 5px;
    padding-bottom: 5px;
    font-size: 12px;
}

.promize-widget-sub-title>i:first-child {
    font-size: 20px;
}

.promize-widget-sub-title {
    text-transform: capitalize;
}

.option-name>i, .promize-widget-sub-title>i:first-child {
    color: #f12e61;
    margin-right: 10px;
    font-size: 14px;
}

.option-name>a {
    position: absolute;
    right: 8px;
    top: 9px;
    height: 20px;
    width: 20px;
    text-align: center;
    padding: 2px;
    font-size: 13px;
    color: #a7abc3;
    transition: all .3s;
    display: none;
}

.promize-dragable-list>li:hover .dragable-items {
    background-color: #f5f5f5;
}
.promize-dragable-list>li.active {
    background-color: #2F89F9;
}

.promize-dragable-list>li:hover .option-name>a {
    display: block;
}

.option-action {
    position: relative;
}

.option-btn {
    padding: 12px 8px 10px 12px;
    border: 0;
    color: #9E9E9E;
    background-color: transparent;
    cursor: grab;
    font-size: 12px;
    position: relative;
    margin-right: 5px;
    display: flex;
}

/* .option-btn:after {
    position: absolute;
    content: "";
    width: 1px;
    height: 15px;
    top: 0;
    right: 2px;
    bottom: 0;
    margin: auto;
    background-color: #d9d9d9;
} */

.promize-tag-items li {
    display: inline-block;
}

.promize-tags {
    padding: 10px 20px;
    background-color: #373b5f;
    color: #fff;
    font-size: 16px;
    border-radius: 7px;
}

.promize-tags .remove-tag {
    cursor: pointer;
}

.promize-widget {
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border-radius: 3px;
    /* -webkit-box-shadow: 0 0 13px 0 rgba(82,63,105,.05);
    box-shadow: 0 0 13px 0 rgba(82,63,105,.05); */
}

.promize-widget-header {
    padding: 10px 15px;
    padding-left: 24px;
    margin-bottom: 0;
    background-color: #FFFFFF;
    display: flex;
    justify-content: flex-start;
    height: 50px;
    position: relative;
}

.promize-drag-icon-vi {
    font-size: 13px;
    display: flex;
    align-items: center;
    position: absolute;
    left: 8px;
    top: 18px;
    color: #a6abc3;
    opacity: 0;
    visibility: hidden;
    transition: all .2s;
}

.promize-widget-header:hover>.promize-drag-icon-vi {
    opacity: 1;
    visibility: visible;
}
.promize-sec-list>li.active {
    background-color: #2F89F9;
    border-radius: 5px;
    overflow: visible;
}

.promize-sec-list>li .dragable-items {
    display: flex;
    align-items: center;
    padding: 0px 0px 0px 10px;
    overflow: visible;
    font-size: 12px;
}

.promize-sec-list>li .dragable-items .btn {
    margin-left: auto;
    width: 30px;
    height: 32px;
    border: 0;
    background-color: transparent;
    color: #a7a4a4;
    font-size: 12px;
}

.promize-sec-list>li.active .dragable-items {
    color: #fff;
}

.promize-sec-list>li.active:hover .dragable-items {
    background-color: transparent;
}

.promize-sec-list>li .dragable-items .btn:hover {
    box-shadow: none;
}

.promize-sec-list>li .dragable-items .btn .promize-btn-description {
    min-width: 80px;
    padding-top: 2px;
}


.promize-sec-list>li.active .dragable-items .btn {
    color: #f1eded;
}

.promize-sec-icon .promize-upload {
    background-color: transparent;
    min-width: 85px;

}

.promize-sec-icon .promize-upload .promize-upload-content {
    background-color: #fff;
}
.promize-widget-title {
    display: flex;
    align-items: center;
    font-size: 15px;
    color: #011838;
    font-weight: normal;
}

.promize-sub-content {
    color: #939393;
    font-size: 12px;
}

.promize-widget-action {
    margin-left: auto;
    margin-right: 30px;
}

.promize-widget-action>ul>li+li {
    margin-left: 15px;
}

.promize-widget-body {
    padding: 15px;
    border-top: 1px solid #E8E8E8;
}

.promize-tab-options {
    display: flex;
    flex-wrap: wrap;
    padding: 0px;
}

.promize-tab-options li {
    display: block;
    padding: 0px;
}
.portlet-menu>li {
    width: 100%;
}
.portlet-menu li+li {
    border-left: 1px solid #DAD9DD;
}

.promize-tab-options-detail {
    width: 250px;
    border-radius: 5px;
    display: flex;
    flex-direction: column-reverse;
    transition: all .2s;
    box-shadow: 0 0 10px rgba(82, 63, 105, .15);
}
.promize-tab-options-detail:hover {
    box-shadow: 0 0 10px rgba(82, 63, 105, .3);
}
.promize-drop-attr {
    width: 100%;
    height: 70px;
    border: 2px dashed #2f89f9;
    background-color: #FCFCFC;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #2f89f9;
    font-size: 14px;
    transition: all .2s;
}

.promize-upload-content.promize-highlight {
    border-color: #2F89F9;
    box-shadow: 0 0 2px 6px rgba(47, 137, 249, 0.3);
}

.promize-drop-attr.promize-highlight {
    border: 0;
    background-color: rgba(47, 137, 249, 0.16);
    color: #011838;
    font-weight: bold;
    background-image: linear-gradient(90deg, #011838 50%, transparent 50%), linear-gradient(90deg, #011838 50%, transparent 50%), linear-gradient(0deg, #011838 50%, transparent 50%), linear-gradient(0deg, #011838 50%, transparent 50%);
    background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
    background-size: 15px 2px, 15px 2px, 2px 15px, 2px 15px;
    background-position: left top, right bottom, left bottom, right top;
    animation: border-animate .2s infinite linear;
}
@keyframes border-animate {
    0% {
      background-position: left top, right bottom, left bottom, right   top;
    }
    100% {
      background-position: left 15px top, right 15px bottom , left bottom 15px , right   top 15px;
    }
  }
.tab-option-container {
    padding: 15px 10px 10px;
    min-height: 200px;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}

.promize-tab-options-detail .tab-option-container img {
    max-width: 180px;
    max-height: 180px;
}

.promize-widget .promize-tab-options li {
    width: 100%;
}

.promize-widget .promize-tab-options-detail {
    width: 100%;
    border-radius: 2px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.promize-widget .tab-option-container {
    min-height: unset;
}

.promize-widget .tab-option-container img {
    max-width: 100px;
    max-height: 100px;
}

.tab-options-prop {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    bottom: -100%;
    background-color: rgba(0, 0, 0, 0.5);
    padding: 10px 15px;
    opacity: 0;
    visibility: hidden;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    transition: all .3s;
}

.tab-options-prop .tab-option-title {
    color: #fff;
    font-weight: bold;
}

.tab-option-container:hover .tab-options-prop {
    bottom: 0;
    opacity: 1;
    visibility: visible;
}

.promize-widget .btn {
    min-width: auto;
    height: 30px;
    line-height: 30px;
    position: relative;
}

.promize-widget .promize-upload-edit {
    display: none;
    position: absolute;
    bottom: 0;
    right: 0;
    box-shadow: none;
    background-color: #f1f2f7;
    line-height: normal !important;
    padding: 0px 8px;
    color: #3b3b3b;
    border-radius: 4px;
}

.promize-upload:hover .promize-upload-edit {
    display: block;
}

.promize-widget .promize-widget-header .btn {
    background-color: transparent;
    margin-left: 5px;
    width: auto;
    font-size: 13px;
    margin-left: 0px;
    padding: 0px 0px;
    min-width: 30px;
    border-radius: 0;
    border: 0;
    font-weight: normal;
    color: #64677b;
    border-radius: 16px;
    position: relative;
}

.promize-widget .promize-widget-header .btn:hover {
    box-shadow: none;
    background-color: #ddddde;
}

.promize-widget .promize-widget-header .btn .clr-bl {
    color: #35649e;
}

.promize-widget-sub-title {
    font-size: 13px;
    font-weight: normal;
    color: #011838;
}

.promize-widget .promize-widget-header .btn:hover {
    box-shadow: none;
}

.btn .promize-btn-description,.btn-prop-lock .promize-btn-description {
    font-weight: normal;
    font-size: 11px;
    position: absolute;
    bottom: 40px;
    left: 50%;
    min-width: 130px;
    background-color: #4e4e4e;
    color: #fff;
    border-radius: 5px;
    box-shadow: 0 5px 10px rgba(82, 63, 105, 0.2);
    min-height: 27px;
    line-height: 25px;
    padding: 0px 5px;
    opacity: 0;
    visibility: hidden;
    transform: translate(-50%,10px);
    transition: all .25s ease-out;
}

.btn:hover .promize-btn-description,.btn-prop-lock:hover .promize-btn-description {
    filter: alpha(opacity=100);
    opacity: 1;
    visibility: visible;
    transform: translate(-50%,0px);
}

.btn:hover .promize-btn-description:after {
    border: 10px solid transparent;
    border-bottom: 0;
    border-top: 10px solid #4e4e4e;
    position: absolute;
    content: "";
    left: 50%;
    bottom: -6px;
    transform: translateX(-50%);
}

.promize-widget .promize-widget-header .promize-widget-toggle .btn {
    line-height: 0;
    color: #64677b;
}

.promize-widget .promize-widget-header .promize-widget-toggle .btn:hover {
    background-color: #f2f3f8;
}

.promize-widget-toggle .btn.toggle {
    transform: rotate(90deg);
}

.promize-widget .tab-option-actions .btn {
    color: #373b5f;
}

.promize-widget-drag {
    position: absolute;
    right: 50px;
    top: 8px;
    color: #a7abc3;
}

.promize-widget-drag .btn {
    color: #a7abc3;
    cursor: move;
}

.tab-option-title {
    margin-top: 5px;
    margin-bottom: 15px;
    color: #3a3535;
    font-size: 14px;
    text-align: center;
    padding: 0px 10px;
}

.tab-option-title::first-letter {
    text-transform: uppercase;
}

.promize-tab-options {
    display: flex;
    flex-wrap: wrap;
    /* padding: 15px 15px; */
}

.promize-widget-body .promize-tab-options {
    padding: 0;
}

.promize-tab-option-header {
    display: flex;
    flex-direction: column;
}

.portlet-menu .btn {
    min-width: auto;
    color: #4c4646;
    padding: 0px 10px;
    width: 100%;
    border-radius: 0;
    text-align: center;
    font-size: 12px;
    border: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-weight: normal;
    line-height: 25px;
}

.promize-tab-options .btn i.fa-ellipsis-v {
    transform: rotate(90deg);
    color: #495057;
}

.option-name span {
    word-break: break-word;
}

.portlet-dropdown-menu {
    display: block;
    padding: 12px 0px 10px;
    /* position: absolute;
    width: 110px;
    display: none;
    right: 5px;
    top: 37px;
    z-index: 1;
    background-color: #fff;
    border-radius: 4px;
    -webkit-box-shadow: 0px 0px 25px 0px rgba(82, 63, 105, 0.25);
    box-shadow: 0px 0px 25px 0px rgba(82, 63, 105, 0.25); */
}

.portlet-dropdown-menu.hide {
    display: block;
}

/* .portlet-dropdown-menu.hide {
    display: none;
}

.portlet-dropdown-menu.show {
    display: block;
} */

.portlet-menu {
    display: flex;
    justify-content: center;
}


.pormize-portlet-dropdown {
    position: relative;
    box-shadow: 0 -2px 10px rgba(82, 63, 105, .1);
}

.button-dropdown {
    min-width: auto;
    width: 34px;
}

.promize-tab-option-header .btn.button-dropdown {
    display: none;
}

.portlet-menu .btn i {
    font-size: 13px;
}

.portlet-menu .btn:hover {
    background-color: #fff;
    box-shadow: none;
    color: #2f89f9;
}

.text-danger {
    color: #F44336 !important;
}

/* CheckBox Style */

.promize-checkbox {
    display: inline-block;
    position: relative;
    padding-left: 22px;
    margin-bottom: 10px;
    text-align: left;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.3s ease;
}

.promize-checkbox>input {
    position: absolute;
    z-index: -1;
    opacity: 0;
}

.promize-checkbox>span {
    border-radius: 2px;
    background: none;
    position: absolute;
    top: 1px;
    left: 0;
    height: 18px;
    width: 18px;
    border: 2px solid #2f89f9;
    transition: all 0.3s ease;
}

.promize-checkbox>span:after {
    content: '';
    position: absolute;
    display: none;
    top: 50%;
    left: 50%;
    margin-left: -3px;
    margin-top: -7px;
    width: 4px;
    height: 10px;
    border: solid #fff;
    border-width: 0 2px 2px 0/*rtl:ignore*/
    !important;
    transform: rotate(45deg)/*rtl:ignore*/
    ;
}
.promize-checkbox>input:checked~span{
    background-color: #2f89f9;
}
.promize-checkbox>input:checked~span:after {
    display: block;
}

/* Radio button Style */

.promize-radio {
    display: inline-block;
    position: relative;
    padding-left: 22px;
    text-align: left;
    margin-bottom: 10px;
    cursor: pointer;
    font-size: 13px;
    transition: all 0.3s ease;
}

.promize-radio>input {
    position: absolute;
    z-index: -1;
    opacity: 0;
}

.promize-radio>.chk-span {
    background: none;
    position: absolute;
    top: -1px;
    left: 0;
    height: 18px;
    width: 18px;
    border-radius: 50% !important;
    background-color: #fff;
    border: 1px solid #A7ABC3;
    transition: all 0.3s ease;
}

.promize-radio>.chk-span:after {
    content: '';
    position: absolute;
    display: none;
    top: 50%;
    left: 50%;
    margin-left: -3px;
    margin-top: -3px;
    width: 6px;
    height: 6px;
    transition: all 0.3s ease;
    background: #ffffff;
    border-radius: 100% !important;
}

.inputgroup .disabled {
    opacity: 0.4;
    pointer-events: none;
    cursor: not-allowed;
}

.inputgroup .disabled.checked {
    opacity: 1;
}

.promize-radio>input:checked~.chk-span {
    background-color: #2f89f9;
    border-color: #2f89f9;
}

.promize-radio>input:checked~.chk-span:after {
    display: block;
}

.widget-body .check-mainbox .inputgroup>div {
    display: flex;
}

.widget-body .check-mainbox label+label {
    margin-left: 6px;
}

.promize-attr-radio {
    padding-left: 40px;
    height: 40px;
    border: 1px solid #D9D9D9;
    border-radius: 5px;
    padding-top: 9px;
    padding-right: 10px;
    color: #434863;
    min-width: 150px;
}

.promize-attr-radio.checked {
    pointer-events: none;
}

.promize-attr-radio:hover {
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.11);
}

.promize-attr-radio .chk-cover {
    position: absolute;
    left: -1px;
    top: -1px;
    height: 40px;
    width: 40px;
    background-color: #fff;
    border: 1px solid #D9D9D9;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
}

.promize-attr-radio>input:checked~.chk-cover {
    background-color: #2D88F9;
    border: 1px solid #2D88F9;
}

.promize-attr-radio .chk-span {
    top: 10px;
    left: 10px;
    border: 1px solid #A7ABC3;
}

.promize-attr-radio>input:checked~.chk-span:after {
    border-color: #fff;
    background-color: #fff;
}

.promize-attr-radio>input:checked~.chk-span {
    border-color: #fff;
}

.promize-attr-radio .chk-icn {
    margin: 0px 10px;
    font-size: 16px;
}

.promize-no-data {
    text-align: center;
}

.promize-no-data img {
    max-width: 200px;
}

.promize-no-data p {
    color: #637381;
    font-weight: bold;
}

.promize-widget-toggle {
    justify-self: flex-end;
}

.promize-widget-toggle .btn i {
    font-size: 20px;
}

.promize-group-upload-items {
    display: flex;
    flex-wrap: wrap;
    margin: 0px -10px;
}

.promize-group-upload-items>li {
    width: 80px;
    height: 80px;
    margin: 0px 10px 10px;
    border: 1px solid #ddd;
}

.promize-uploded-image {
    padding: 2px;
    border-radius: 2px;
    position: relative;
    overflow: hidden;
    display: flex;
    height: 100%;
    width: 100%;
    justify-content: center;
    align-items: center;
}

.promize-group-upload-items>li .promize-uploded-image img {
    max-width: 100%;
    max-height: 74px;
}

.promize-group-upload>p {
    margin-bottom: 10px;
}

.promize-uploded-image .promize-upload-delete {
    position: absolute;
    top: 100%;
    height: 100%;
    width: 100%;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all .3s;
}

.promize-uploded-image:hover .promize-upload-delete {
    top: 0;
}

.promize-upload-delete i {
    padding: 6px 7px;
    border: 1px solid #fff;
    border-radius: 2px;
    cursor: pointer;
}

.btn-tbl.delete {
    color: #f36842;
}

.promize-view-container {
    display: flex;
    border: 1px solid #e6e6e6;
    border-radius: 5px;
    position: relative;
    overflow: hidden;
}

.promize-option-container {
    background-color: #fff;
    margin: 0px auto;
    padding: 20px;
    position: relative;
    width: 90%;
}

.promize-option-container .canvas-container {
    margin: 0px auto;
    max-width: 400px;
    height: auto !important;
    border: 1px solid #ececec;
    padding: 10px;
    width: auto !important;
    height: 300px !important;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}

.promize-option-container .canvas-container>canvas {
    max-width: 100%;
    height: auto !important;
    position: relative !important;
    max-height: 280px;
    width: auto !important;
}

.promize-option-container .canvas-container>canvas:last-child {
    position: absolute !important;
    max-width: calc(100% - 20px);
    margin: auto;
    right: 0;
    bottom: 0;
    width: auto !important;
    max-height: 280px;
}

.promize-opt-thumb {
    width: 90px;
    background: #fff;
    margin-left: 10px;
    margin-top: 10px;
    font-size: 12px;
}

.promize-stp-options {
    position: absolute;
    top: 20px;
    right: 40px;
    display: flex;
    flex-direction: column;
}
.promize-stp-options .btn-promize-secondary{
 margin: 0;
}
.promize-stp-options .btn-promize-secondary+.btn-promize-secondary{
    margin-top: 10px;
}
.thumb-itm {
    border: 1px solid #ddd;
    padding: 10px;
    opacity: 0.5;
    cursor: pointer;
}
.thumb-itm+.thumb-itm{
    margin-top: 10px;
}
.thumb-itm.current-item {
    border: 1px solid #2F89F9;
    cursor: default;
    opacity: 1;
}
.thumb-itm img {
    max-width: 50px;
    max-height: 50px;
}

.promize-set-position .promize-slide-icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    font-size: 30px;
    color: #9A9A9A;
    font-weight: 100;
    padding: 2px 10px;
    cursor: pointer;
}

.sub-tab-content {
    position: relative;
    margin-left: 40px;
}

.sub-tab-content:before {
    content: "";
    position: absolute;
    left: -25px;
    top: -10px;
    height: calc(100% - 15px);
    width: 22px;
    border: 1px dashed #707070;
    border-top: 0;
    border-right: 0;
}

.sub-tab-content+.sub-tab-content:before {
    top: -45px;
    height: calc(100% + 20px);
}

.promize-clipart-options {
    display: flex;
    flex-wrap: wrap;
}

.promize-clipart-options>li {
    margin-right: 10px;
    margin-bottom: 10px;
}

.promize-clipart-thumb {
    text-align: center;
    font-size: 14px;
    padding: 5px 10px;
    border: 1px solid #e8e8e8;
    border-radius: 5px;
}

.promize-clipart-thumb img {
    max-width: 60px;
    max-height: 60px;
}

.promize-slide-icon.promize-canvas-prev-btn {
    left: 20px;
}

.promize-slide-icon.promize-canvas-next-btn {
    right: 10px;
}

.promize-set-position input[type=number]::-webkit-inner-spin-button, .promize-set-position input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
}

.promize-canvas-hw {
    position: relative;
}

.promize-canvas-hw .prop-lock-hw {
    position: absolute;
    right: -45px;
    top: 53%;
    transform: translateY(-50%);
}

.btn-prop-lock {
    font-size: 12px;
    padding: 6px 8px;
    border: 1px solid #D9D9D9;
    color: #D9D9D9;
    border-radius: 3px;
    cursor: pointer;
    transition: all .3s;
    background-color: #fff;
}

.promize-set-position .promize-form-group {
    margin-bottom: 10px;
}

.promize-set-position .promize-form-group label {
    color: #202646;
    font-weight: bold;
    font-size: 11px;
}

.promize-slider-dot-items li {
    background-color: #D1D1D1;
    height: 10px;
    width: 10px;
    border-radius: 6px;
    cursor: pointer;
}



.promize-slider-dot-items li+li {
    margin-left: 10px;
}

.promize-image-collection {
    margin-left: auto;
    margin-right: auto;
    padding: 10px 15px;
    margin-top: 10px;
    background-color: #fff;
    border: 1px solid #757575;
    border-radius: 3px;
}

.promize-coll-images-items {
    border: 1px solid #e8e8e8;
    background-color: #fff;
    padding: 5px;
    text-align: center;
    border-radius: 3px;
    cursor: pointer;
    margin-right: 20px;
    margin-bottom: 20px;
}

.promize-coll-images-items>img {
    max-width: 70px;
    max-height: 70px;
}

.promize-img-coll-detail {
    padding-right: 20px;
    margin-right: 20px;
    border-right: 1px solid #C5C5C5;
    text-align: right;
    font-family: "Lato";
}

.promize-img-coll-title {
    color: #202646;
    font-size: 15px;
}

.promize-img-coll-subtitle {
    font-size: 12px;
    color: #b5b5b5;
}

.promize-coll-images-items.disabled {
    opacity: .4;
    cursor: not-allowed;
}

.promize-slide-icon.disabled {
    opacity: .2;
    cursor: default;
    pointer-events: none;
}

.btn-prop-lock.locked {
    color: #fff;
    border: 1px solid #202646;
    background-color: #202646;
}

.promize-milist {
    display: flex;
    flex-wrap: wrap;
}

.promize-milist>li>img {
    max-width: 40px;
    max-height: 40px;
}

.promize-milist>li {
    margin-right: 5px;
    padding: 2px;
    border: 1px solid #ddd;
    display: flex;
    align-items: center;
}

.promize-tbl-img-sm {
    max-width: 40px;
    max-height: 40px;
}

.promize-card-setting {
    background-color: #fff;
    padding: 25px;
    border-radius: 5px;
    margin-right: 20px;
    margin-bottom: 20px;
    cursor: pointer;
    box-shadow: 0 0 13px 0 rgba(82, 63, 105, .05);
    transition: all .3s;
}

.promize-card-setting:hover {
    box-shadow: 0 10px 13px 0 rgba(82, 63, 105, .2);
}

.promize-settings-icon {
    height: 50px;
    width: 50px;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 25px;
    margin-bottom: 20px;
}

a {
    text-decoration: none;
}

.promize-settings-icon i {
    font-size: 22px;
}

.bg-lg-bl {
    background-color: rgba(45, 136, 249, 0.1);
}

.clr-bl {
    color: #2D88F9;
}

.clr-org {
    color: #FF8969;
}

.bg-lg-gr {
    background-color: rgba(74, 143, 0, 0.1);
}

.clr-gr {
    color: #4B8F00;
}

.bg-lg-rd {
    background-color: rgba(206, 25, 73, 0.1)
}

.clr-rd {
    color: #CE1949;
}

.bg-lg-yl {
    background-color: rgba(252, 189, 89, 0.1)
}

.clr-yl {
    color: #FCBD59;
}

.promize-settings-header {
    color: #011838;
    font-size: 15px;
    font-weight: bold;
    margin-bottom: 15px;
}

.promize-settings-desc {
    font-size: 14px;
    color: #989BAD;
}

.promize-prdt-section-conatiner>ul {
    border-bottom: 1px solid #D0D0D0;
}

.promize-prdt-section-list>li.active:after {
    position: absolute;
    content: "";
    height: 4px;
    width: 100%;
    left: 0;
    bottom: -1px;
    background-color: #2f89f9;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
}

.promize-prdt-section-list>li {
    position: relative;
    display: inline-block;
    padding: 10px 15px;
    height: 40px;
    font-size: 15px;
    color: #7d8196;
    transition: all .2s;
}

.promize-prdt-section-list>li.active {
    color: #011838;
}

.promize-section-name .promize-section-status {
    height: 8px;
    width: 8px;
    display: inline-block;
    margin-right: 6px;
    border-radius: 4px;
}

.promize-section-name {
    cursor: pointer;
    white-space: nowrap;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
}

.promize-section-name span {
    white-space: nowrap;
}

.promize-section-name .edit-icon {
    border-radius: 3px;
    visibility: hidden;
    position: absolute;
    right: -8px;
    bottom: 6px;
    padding: 4px 0px;
    background-color: transparent;
    border: 1px solid transparent;
    font-size: 13px;
    height: 26px;
    width: 18px;
    text-align: center;
    color: #676464;
    cursor: pointer;
    transform: translateX(-15px);
    opacity: 0;
    transition: all .3s;
}
.promize-prdt-section-list>li:hover {
    color: #464242;
}
.promize-prdt-section-list>li:hover .edit-icon {
    transform: translateX(0);
    opacity: 1;
    visibility: visible;
}

.promize-section-status.active {
    background-color: #20CE09;
}

.promize-section-status.in-active {
    background-color: #FF8969;
}

.btn-rnd {
    color: #6b6e82;
    border: 1px solid #6b6e82;
    height: 30px;
    line-height: 30px;
    border-radius: 15px;
    padding: 0px 15px;
    font-size: 12px;
    background-color: #f2f3f8;
}

.pormize-abs-rght {
    position: absolute;
    right: 0;
    top: 0px;
}

.promize-card-edit {
    position: absolute;
    width: 300px;
    z-index: 1;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.4);
    border-radius: 3px;
}

.promize-prdt-section-conatiner {
    position: relative;
}

.promize-configure-wrapper {
    display: flex;
    height: 100vh;
}

.promize-overlay-container {
    width: 62%;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) rgba(1, 24, 56, 0.8);
    padding-left: 50px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-blend-mode: multiply;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100%;
}

.promize-config-form {
    width: 38%;
    background-color: #011838;
    padding: 0px 60px;
}

.promize-logo-sm>img {
    max-width: 100px;
}

.promize-logo-sm {
    text-align: center;
    margin-top: 100px;
    margin-bottom: 40px;
}

.promize-form-title {
    color: #fff;
    font-size: 25px;
    text-align: center;
    margin: 20px 0px;
    font-weight: normal;
}

.promize-config-form .promize-form-control {
    height: 46px;
    background-color: transparent;
    border-color: rgba(255, 255, 255, 0.6);
    color: rgba(255, 255, 255, 0.6);
}
.promize-config-form .promize-form-control:focus {
    border-color: #2f89f9;
}
.promize-config-form .promize-form-control-label {
    font-size: 16px;
    margin-bottom: 10px;
    color: rgba(255, 255, 255, 0.6);
}

.promize-config-form .promize-form-group {
    margin-bottom: 40px;
}

.promize-config-form .btn-promize-primary {
    width: 100%;
    height: 46px;
    font-size: 20px;
    font-weight: normal;
}
.promize-config-form .btn-promize-primary:hover {
    border: 1px solid #076cec;
    background-color: #076cec;
}
.promize-config-form p {
    text-align: center;
    margin-top: 60px;
    font-size: 16px;
    color: rgba(255, 255, 255, 0.6);
}

.promize-configure-wrapper a {
    color: #3089fa;
}

.promize-logo-lg {
    margin-top: 50px;
}

.promize-work {
    margin-bottom: 50px;
}

.promize-key-value {
    color: #fff;
}

.promize-key-value .promize-secondary-title {
    font-size: 30px;
    font-weight: normal;
}

.promize-key-value .promize-primary-title {
    font-size: 40px;
    font-weight: bold;
}

.promize-highlight-text {
    border-bottom: 5px solid #3089fa;
    padding-bottom: 5px;
}

.promize-attribute-options>div {
    color: #434863;
    font-size: 13px;
}
.promize-attr-content {
    display: flex;
    align-items: flex-start;
}
.promize-attr-option-title {
    min-width: 160px;
    display: flex;
    justify-content: space-between;
}
.promize-attr-option-value {
    margin-left: 10px;
}
.promize-attr-option-value>span{
    margin-right: 10px;
    margin-bottom: 5px;
}
.promize-attribute-options>div:not(:last-child) {

}

.promize-attribute-options>div>span {
    display: inline-block;
}

.promize-attribute-options>div>span:first-child {
    width: 160px;
}

.promize-attribute-options>div>span:nth-child(2) {
    width: 30px;
    text-align: left;
}

.promize-attribute-options>div>span:last-child {
    font-weight: bold;
    font-size: 13px;
}

.promize-work a {
    position: relative;
    padding-left: 50px;
    color: #fff;
}

.promize-work a i {
    position: absolute;
    left: 16px;
    top: 3px;
    color: #fff;
    font-size: 12px;
}

.promize-work a:before {
    content: "";
    position: absolute;
    height: 40px;
    width: 40px;
    left: 0;
    top: -12px;
    background-color: #3089fa;
    border-radius: 20px;
}

.promize-popup {
    position: fixed;
    width: 100%;
    left: 0;
    right: 0;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    text-align: center;
    padding-top: 100px;
}

.promize-popup-inner {
    position: relative;
    box-shadow: 0 0px 15px black;
    display: inline-block;
}

.popup-close {
    position: absolute;
    top: -16px;
    right: -16px;
    height: 36px;
    width: 36px;
    border-radius: 18px;
    font-size: 16px;
    background-color: #fff;
    color: #000000;
}

/* fade in componets */

.fade-in-section {
    opacity: 0;
    transform: translateY(20vh);
    visibility: hidden;
    transition: opacity 1200ms ease-out, transform 600ms ease-out, visibility 1200ms ease-out;
    will-change: opacity, transform, visibility;
}

.fade-in-section.is-visible {
    opacity: 1;
    transform: none;
    visibility: visible;
}

.promize-dashboard>img {
    width: 100%;
    height: auto;
}

.promize-dashboard {
    margin-top: 20px;
}

.promize-coming-soon>img {
    max-width: 500px;
    margin-top: 100px;
}

.promize-coming-soon {
    text-align: center;
}

.promize-text-options {
    display: flex;
    flex-wrap: wrap;
}

.promize-text-highlight-aa {
    padding: 3px 8px;
    background-color: #efefef;
    border-radius: 3px;
    font-size: 12px;
    margin-bottom: 4px;
    margin-right: 3px;
}

.promize-text-options>li {
    margin-bottom: 4px;
    margin-right: 3px;
}

.css-2b097c-container:focus {
    outline: 0;
}

.css-yk16xz-control {
    border-color: #D9D9D9;
}

.css-1pahdxg-control:hover {
    box-shadow: none;
}

.css-1rhbuit-multiValue {
    background-color: hsl(213, 94%, 58%);
}

.css-12jo7m5 {
    color: #fff;
}

.css-1alnv5e {
    cursor: pointer;
}

.css-1rhbuit-multiValue .css-tj5bde-Svg {
    fill: #f1f1f1;
}

.promize-rule-container .promize-widget {
    border: 1px solid #A7ABC3;
    border-radius: 0;
}
.promize-rule-container .promize-widget-title
{
    padding-right: 50px;
}
.promize-rule-container>.promize-widget.collapse {
    max-height: 50px;
    overflow: hidden;
    transition: max-height .5s;
}
.promize-rule-container>.promize-widget.collapse.open {
    max-height: 1500px;
    transition: max-height .5s;
}
.promize-rule-container .promize-widget-toggle {
    margin-left: auto;
}
.promize-rule-container .promize-widget.open .promize-widget-toggle.btn
{
    transform: rotate(90deg);
}
.promize-rule-container .promize-widget-body {
    border: 0;
}

.promize-widget-title .edit-icon {
    border-radius: 3px;
    display: none;
    position: absolute;
    right: calc(-25px + 50px);
    bottom: 3px;
    padding: 4px 0px;
    background-color: transparent;
    border: 1px solid transparent;
    font-size: 13px;
    height: 26px;
    width: 18px;
    text-align: center;
    color: #9e9e9e;
    cursor: pointer;
    transition: all .3s;
}

.promize-widget-title:hover>.edit-icon {
    display: block;
}


.promize-widget-title {
    position: relative;
}

.rule-block {
    position: relative;
}
.promize-rule-container .promize-form-group{
    margin-bottom: 15px;
}
.rule-condition .promize-form-group {
    margin: 0px 5px;
}
.rule-condition .promize-form-control {
    height: 30px;
    width: 80px;
}
.rule-block:before {
    position: absolute;
    content: "";
    width: 15px;
    height: 50px;
    border: 1px dashed #6d6d6d;
    border-top: 0px;
    border-right: 0px;
    top: 33px;
    left: 3px;
}

.promize-rule-container .btn-rule-condition {
    background-color: transparent;
    margin-left: 5px;
    width: auto;
    font-size: 14px;
    margin-left: 0px;
    padding: 0px 0px;
    min-width: 30px;
    border-radius: 0;
    border: 0;
    font-weight: normal;
    color: #A7ABC3;
    border-radius: 16px;
    position: relative;
    margin-top: 10px;
}
.promize-rule-container .promize-form-control
{
    font-size: 13px;
}

/* .promize-condition-list .rule-condition-item+.rule-condition-item:before {
    position: absolute;
    content: "";
    width: 20px;
    height: 86px;
    border: 1px dashed #6d6d6d;
    border-right: 0px;
    bottom: 44px;
    left: -20px;
}
.promize-condition-list .rule-condition-item+.rule-condition-item:after {
    position: absolute;
    content: "+";
    width: 20px;
    height: 20px;
    border: 1px solid #6d6d6d;
    bottom: 78px;
    left: -30px;
    font-size: 16px;
    text-align: center;
    font-weight: bold;
    background-color: #f2f3f8;
    border-radius: 15px;
} */

.rule-condition-item {
    position: relative;
}
.promize-rule-action {
    position: relative;
}

.promize-rule-action:before {
    position: absolute;
    content: "";
    width: 15px;
    height: 55px;
    border: 1px dashed #6d6d6d;
    border-top: 0px;
    border-right: 0px;
    top: -20px;
    left: 15px;
}

.promize-rule-container .promize-widget .btn-promize-primary,.promize-rule-container .promize-widget .btn-promize-secondary {
    height: 40px;
    line-height: normal;
    min-width: 90px;
}
.promize-rule-container .promize-widget-header
{
    padding: 7px 15px;
    min-height: 50px;
}
.promize-title-edit {
    display: flex;
    align-items: center;
}

.promize-title-edit .promize-form-control {
    height: 36px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right: 0;
}

.promize-title-edit-save {
    height: 36px;
    width: 36px;
    background-color: #fff;
    color: #4B8F00;
    border: 1px solid #d9d9d9;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
}

.promize-title-edit .promize-form-group>label:empty {
    display: none;
}

.promize-title-edit .promize-form-group {
    margin: 0;
}
.promize-option-titl-list {
    display: flex;
    justify-content: space-between;
}
.promize-option-content+.promize-option-content {
    margin-top: 10px;
}

.promize-option-content-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 5px;
    border: 0;
    background-color: #fff;
    box-shadow: 0 0 13px rgba(82, 63, 105, 0.10);
    padding: 8px 5px;
}
.promize-option-content-list .promize-form-group {
    margin: 0;
}

.promize-option-content-list .promize-form-control {
    height: 32px;
    font-size: 12px;
}
.promize-option-titl-list>div {
    width: 10%;
    font-size: 12px;
    padding: 5px 3px;
}

.promize-option-content-list>div {
    width: 10%;
    font-size: 12px;
}

.promize-option-titl-list>div:last-child {
    width: 80px;
}

.promize-option-content-list>div:last-child button+button {
    margin-left: 3px;
}

.promize-option-content-list>div:last-child {
    width: 85px;
}
.promize-option-titl-list>div:nth-child(2),.promize-option-content-list>div:nth-child(2) {
    width: 10%;
}
.promize-option-titl-list>div:nth-child(3),.promize-option-content-list>div:nth-child(3) {
    width: 10%;
}
.promize-option-titl-list>div:nth-child(4),.promize-option-content-list>div:nth-child(4) {
    width: 10%;
}
.promize-option-titl-list>div:nth-child(5),.promize-option-content-list>div:nth-child(5) {
    width: 10%;
}
.promize-option-titl-list>div:nth-child(6),.promize-option-content-list>div:nth-child(6) {
    width: 10%;
}
.promize-option-titl-list>div:nth-child(7),.promize-option-content-list>div:nth-child(7) {
    width: 10%;
}
.promize-option-titl-list>div:nth-child(8),.promize-option-content-list>div:nth-child(8) {
    width: 10%;
}
.promize-option-content-list>div:not(:first-child) {
    padding: 0px 5px;
}
/* General Settings */
.promize-general-settings .promize-card-title h3 span {
    font-size: 20px;
}
.promize-general-settings {
    margin-bottom: 30px;
}

.promize-general-settings .promize-card-title h3 {
    margin: 0;
}

.promize-questions>p {
    margin-top: 10px;
    color: #011837;
}


.promize-general-settings .promize-radio, .promize-general-settings .promize-checkbox {
    display: block;
    font-size: 13px;
}

.promize-general-settings .promize-checkbox {
    padding-top: 4px;
    padding-bottom: 5px;
}

.ques-container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 10px;
    padding: 8px 5px;
    transition: all .3s;
}

.promize-ques {
    margin-top: 5px;
}

.ques-container:hover {
    background-color: #f1f1f1;
}
.ques-container .check-mainbox{
    width: 100%;
    margin-left: 20px;
}
.ques-container .check-mainbox:nth-of-type(1n):last-child {
      width: unset;
}

.input-range__label--value{
    display: none;
}

/* React select  */
.css-4ljt47-MenuList {
    max-height: 130px;
}

/* 3D product Design */

.promize-3d-parts-list {
    margin-top: 20px;
}
.promize-3d-parts-list>li {
    display: inline-block;
    padding: 5px 15px;
    height: 25px;
    background-color: rgba(98, 153, 221, 0.1);
    color: #6299dd;
    margin-right: 5px;
    margin-bottom: 5px;
    border-radius: 15px;
    font-size: 12px;
}

.pz-intro-cover * {
    box-sizing: border-box;
    font-family: 'Lato', sans-serif;
}

.pz-intro-cover {
    position: fixed;
    height: 100%;
    width: 100%;
    left: 0;
    right: 0;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    display: none;
}

.pz-intro {
    max-width: 700px;
    height: 420px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    border: 1px solid #999;
    background-color: #fff;
}

.pz-intro-title {
    text-align: center;
    font-size: 45px;
    margin-bottom: 30px;
}

.pz-intro-text {
    font-size: 20px;
    text-align: center;
    margin-bottom: 70px;
}

.pz-intro-proceed {
    text-align: center;
}

.pz-lets-start-btn {
    height: 50px;
    font-size: 18px;
    padding: 5px 30px;
    border: 1px solid #3b91fa;
    background-color: #3b91fa;
    color: #fff;
    cursor: pointer;
    transition: all .3s;
}

.pz-lets-start-btn:hover {
    background-color: #0d2250;
    border-color: #0d2250;
}
/*

.promize-highlight-v1 {
    background-color: rgba(59, 145, 250, 0.2);
    padding: 2px 5px;
    border-radius: 5px;
    color: #0c55af;
    font-weight: 400;
    font-size: 13px;
}
.ul-style-disc
{
    list-style-type: disc;
}
.ul-style-circle
{
    list-style-type: circle;
}
.img-responsive
{
    max-width: 100%;
}
*/

/*************USER GUID CSS *****************/

.promize-highlight-v1 {
    background-color: rgba(59, 145, 250, 0.2);
    padding: 5px 14px 6px;
    border-radius: 5px;
    color: #0c55af;
    font-size: 16px;
    font-weight: bold;
}

.ul-style-disc {
    list-style-type: disc;
}

.ul-style-circle {
    list-style-type: circle;
}

.img-responsive {
    max-width: 100%;
}

.pz-user-guide-content p {
    line-height: 1.5;
}

.pz-user-guide-cover {
    width: 250px;
    flex: 250px 0;
    align-self: flex-start;
    position: sticky;
    top: 50px;
    border-right: 1px dashed #949494;
    padding-bottom: 50px;
    padding-right: 15px;
}

.pz-user-guide-menu-list>li {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    position: relative;
    transition: all .2s;
}

.pz-user-guide-menu-list>li>a {
    width: 100%;
    height: 100%;
    padding: 8px 0px;
    color: #6d747c;
    line-height: 1.8;
    padding-left: 10px;
    border: 0;
}
.pz-user-guide-menu-list>li>a:focus, .pz-user-guide-menu-list>li>a:active {
    border: 0;
    outline: 0;
}
.pz-user-guide-menu-list>li.active:before {
    content: "";
    position: absolute;
    height: 100%;
    width: 4px;
    background-color: #1c2160;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

.pz-user-guide-menu-list>li:hover {
    background-color: #f2f3f8;
}
.pz-user-guide-content p,.pz-user-guide-content li{
    line-height: 1.8;
}
.user-guide-title
{
    font-size: 25px;
}


xmp {
    font-size: 12px;
    margin-top: 0;
    max-width: 100%;
    overflow-x: auto;
}
/* *************** */



/* Media Queris */

@media only screen and (max-width: 1399px) {
    .promize-modal.modal-lg {
        max-width: 85%;
    }
    .promize-logo-sm>img {
        max-width: 80px;
    }
    .promize-form-title {
        font-size: 20px;
    }
    .promize-logo-sm {
        margin-bottom: 30px;
        margin-top: 80px;
    }
    .promize-config-form .promize-form-control {
        height: 38px;
    }
    .promize-config-form .btn-promize-primary {
        height: 38px;
        font-size: 16px;
        margin-top: 20px;
    }
    .promize-config-form .promize-form-group {
        margin-bottom: 25px;
    }
    .promize-config-form p {
        margin-top: 40px;
    }
    .promize-table tbody tr td
    {
        padding: 6px 10px;
        font-size: 13px;
    }
}

.wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100vh;
}

.preloader {
    display: block;
    width: 200px;
    height: 200px;
    border-radius: 50%;
    border: 5px solid transparent;
    border-top-color: #3089f9;
    position: relative;
    animation: rotating 2.5s infinite ease;
    -webkit-animation: rotating 2.5s infinite linear;
}

.preloader:after, .preloader:before {
    content: "";
    position: absolute;
    border-radius: inherit;
    border: inherit;
}

.preloader:after {
    top: 5px;
    left: 5px;
    width: 180px;
    height: 180px;
    border-top-color: #f89f11;
    animation: rotating 2s infinite ease;
    -webkit-animation: rotating 2s infinite linear;
}

.preloader:before {
    top: 15px;
    left: 15px;
    width: 160px;
    height: 160px;
    border-top-color: #fa4978;
    animation: rotating 1.5s infinite ease;
    -webkit-animation: rotating 1.5s infinite linear;
}


.wrapperopacity {
    left: 0;
    top :0;
    z-index: 1;
    position:fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100vh;
}

.wrapperopacity:after {
    content: '';
    background: #000000;
    opacity: 0.3;
    position: fixed;
    width: 100%;
    height: 100vh;
}

.preloaderopacity {
    display: block;
    width: 200px;
    height: 200px;
    border-radius: 50%;
    border: 5px solid transparent;
    border-top-color: #3089f9;
    position: relative;
    animation: rotating 2.5s infinite ease;
    -webkit-animation: rotating 2.5s infinite linear;
}

.preloaderopacity:after, .preloaderopacity:before {
    content: "";
    position: absolute;
    border-radius: inherit;
    border: inherit;
}

.preloaderopacity:after {
    top: 5px;
    left: 5px;
    width: 180px;
    height: 180px;
    border-top-color: #f89f11;
    animation: rotating 2s infinite ease;
    -webkit-animation: rotating 2s infinite linear;
}

.preloaderopacity:before {
    top: 15px;
    left: 15px;
    width: 160px;
    height: 160px;
    border-top-color: #fa4978;
    animation: rotating 1.5s infinite ease;
    -webkit-animation: rotating 1.5s infinite linear;
}


@keyframes rotating {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/theme.css"],"names":[],"mappings":";;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,yBAAyB;EAGzB,iBAAiB;AACnB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,SAAS;EACT,QAAQ;AACV;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA,+CAA+C;AAC/C;EACE,sBAAsB;AACxB;;AAEA,wDAAwD;AACxD;EACE,yBAAyB;AAC3B;;AAEA,6DAA6D;AAC7D;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA,oCAAoC;AACpC;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,SAAS;EACT,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EAGzB,wBAAwB;AAC1B;;AAEA;QACQ,qBAAqB;IACzB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,cAAc;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,OAAO;EACP,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,kBAAkB,CAAC,aAAa;AAClC;AACA;IACI,iBAAiB;AACrB;;AAEA;QACQ,qBAAqB;IACzB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;;;;AAKA;IACI,SAAS;IACT,UAAU;IACV,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAIA;IACI,yBAAyB;IACzB,SAAS;IACT,YAAY;IACZ,+BAA+B;IAC/B,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA,UAAU;;AAEV;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,WAAW;;AAEX;IACI,mBAAmB;IACnB,kBAAkB;IAClB,2BAAmB;IAAnB,mBAAmB;AACvB;;AAEA,oBAAoB;;AAEpB;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;AACA;IACI,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,uCAAuC;IACvC,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAEhB,6CAA6C;AACjD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,sBAAsB;IACtB,sBAAsB;IACtB,SAAS;IACT,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,cAAc;AAClB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,OAAO;AACX;AACA;IACI,iBAAiB;AACrB;AACA;IACI,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,4BAA4B;IAC5B,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,0CAA0C;IAC1C,cAAc;AAClB;AACA;IACI,8BAA8B;IAC9B,+DAA+D;IAC/D,4CAA4C;IAC5C,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,4CAA4C;AAChD;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,kBAAkB;IAClB,iBAAiB;IACjB,uCAAuC;IACvC,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,YAAY;IACZ,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,cAAc;IACd,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,cAAc;IACd;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,0BAA0B;IAC1B,SAAS;IACT,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,6BAA6B;IAC7B,6BAA6B;IAC7B,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,iBAAiB;AACrB;AACA;IACI,sBAAsB;IACtB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,2BAA2B;IAC3B,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yCAAyC;IACzC,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IAEzB,iBAAiB;AACrB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,oEAAoE;AACxE;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,sDAAsD;IACtD,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,YAAY;IACZ,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,qBAAqB;IACrB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,oCAAoC;IACpC,YAAY;IACZ,WAAW;IACX,MAAM;IACN,OAAO;IACP,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,UAAU;IACV,OAAO;IACP,QAAQ;IACR,kBAAkB;IAClB,gBAAgB;IAChB,uCAAuC;IAIvC,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,UAAU;IACV,OAAO;IACP,MAAM;IACN,QAAQ;IACR,kBAAkB;IAClB,gBAAgB;IAChB,uCAAuC;IAIvC,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,UAAU;IACV,OAAO;IACP,MAAM;IACN,QAAQ;IACR,kBAAkB;IAClB,gBAAgB;IAChB,uCAAuC;IAIvC,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;AACA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,6BAA6B;IAC7B,eAAe;IACf,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;AACpC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,uBAAuB;IACvB,2BAA2B;AAC/B;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,YAAY;IACZ,WAAW;IACX,UAAU;IACV,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,wBAAwB;IACxB,SAAS;IACT,UAAU;IACV,0CAA0C;IAC1C,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,oCAAoC;IACpC,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,2BAA2B;AAC/B;AACA;;IAEI,aAAa;AACjB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;;IAEI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,0BAA0B;IAC1B,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,SAAS;IACT,cAAc;IACd,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;;;;;;;;;;GAUG;;AAEH;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAElB,aAAa;IAEb,sBAAsB;IACtB,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB;iDAC6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,2BAA2B;IAC3B,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,6BAA6B;IAC7B,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;;AAGA;IACI,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;;AAEnB;;AAEA;IACI,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;AACA;IACI,WAAW;AACf;AACA;IACI,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,2CAA2C;AAC/C;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,+CAA+C;AACnD;;AAEA;IACI,SAAS;IACT,0CAA0C;IAC1C,cAAc;IACd,iBAAiB;IACjB,sOAAsO;IACtO,yDAAyD;IACzD,uDAAuD;IACvD,mEAAmE;IACnE,6CAA6C;AACjD;AACA;IACI;MACE,qEAAqE;IACvE;IACA;MACE,2FAA2F;IAC7F;EACF;AACF;IACI,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,OAAO;IACP,aAAa;IACb,oCAAoC;IACpC,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gBAAgB;IAChB,yBAAyB;IACzB,8BAA8B;IAC9B,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,6CAA6C;IAC7C,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAKlB,+BAA+B;IAK/B,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;IAC1B,UAAU;IACV,mBAAmB;IAKnB,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,8BAA8B;IAC9B,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB;;;;;;;;;2DASuD;AAC3D;;AAEA;IACI,cAAc;AAClB;;AAEA;;;;;;GAMG;;AAEH;IACI,aAAa;IACb,uBAAuB;AAC3B;;;AAGA;IACI,kBAAkB;IAClB,6CAA6C;AACjD;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,mBAAmB;;AAEnB;IACI,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,eAAe;IAEf,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,YAAY;IACZ,WAAW;IACX,yBAAyB;IAEzB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB;cACU;IAGV;IACA;AACJ;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;AAClB;;AAEA,uBAAuB;;AAEvB;IACI,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,eAAe;IAEf,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,YAAY;IACZ,WAAW;IACX,6BAA6B;IAC7B,sBAAsB;IACtB,yBAAyB;IAEzB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,yBAAyB;IACzB,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,WAAW;IACX,OAAO;IACP,oCAAoC;IACpC,WAAW;IACX,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,wBAAwB;IACxB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,6BAA6B;IAC7B,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;IAC5B,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;AACA;CACC,SAAS;AACV;AACA;IACI,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,aAAa;IACb,YAAY;IACZ,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,eAAe;IACf,UAAU;AACd;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,yBAAyB;IACzB,WAAW;IACX,0BAA0B;IAC1B,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;;;;AAIA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,+BAA+B;IAC/B,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IAEf,6CAA6C;IAC7C,mBAAmB;AACvB;;AAEA;IAEI,+CAA+C;AACnD;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,WAAW;IACX,OAAO;IACP,YAAY;IACZ,yBAAyB;IACzB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,6BAA6B;IAC7B,6BAA6B;IAC7B,eAAe;IACf,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,4BAA4B;IAC5B,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,cAAc;AAClB;AACA;IACI,wBAAwB;IACxB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,wEAAgE;IAChE,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,+BAA+B;IAC/B,4BAA4B;IAC5B,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,sCAAsC;IACtC,+BAA+B;AACnC;AACA;IACI,qBAAqB;AACzB;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;AACA;;AAEA;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,OAAO;IACP,UAAU;IACV,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IACtB,cAAc;AAClB;;AAEA,sBAAsB;;AAEtB;IACI,UAAU;IACV,2BAA2B;IAC3B,kBAAkB;IAClB,yFAAyF;IACzF,2CAA2C;AAC/C;;AAEA;IACI,UAAU;IACV,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;AACA;;IAEI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,0BAA0B;AAC9B;AACA;IACI,kBAAkB;IAClB,0BAA0B;AAC9B;AACA;IACI,iBAAiB;AACrB;AACA;;IAEI,wBAAwB;AAC5B;AACA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,6BAA6B;IAC7B,6BAA6B;IAC7B,eAAe;IACf,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;AACA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;IACjB,SAAS;IACT,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;;IAEI,eAAe;AACnB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;GAuBG;;AAEH;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;IACjB,UAAU;IACV,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;AACA;;IAEI,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,0BAA0B;IAC1B,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,cAAc;IACd,yBAAyB;IACzB,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;AACb;AACA;IACI,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,sBAAsB;IACtB,4CAA4C;IAC5C,gBAAgB;AACpB;AACA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;AACA;IACI,UAAU;IACV,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,gBAAgB;AACpB;AACA,qBAAqB;AACrB;IACI,eAAe;AACnB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;;AAGA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,iBAAiB;AACrB;AACA;MACM,YAAY;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA,kBAAkB;AAClB;IACI,iBAAiB;AACrB;;AAEA,sBAAsB;;AAEtB;IACI,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,YAAY;IACZ,yCAAyC;IACzC,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,OAAO;IACP,QAAQ;IACR,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;;;;;;;;;;;;;;;;;;;;;;CAsBC;;AAED,6CAA6C;;AAE7C;IACI,yCAAyC;IACzC,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAe;IACf,sBAAsB;IAEtB,gBAAgB;IAChB,SAAS;IACT,gCAAgC;IAChC,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,gBAAgB;AACpB;AACA;;IAEI,eAAe;AACnB;;;AAGA;IACI,eAAe;IACf,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;AACA,oBAAoB;;;;AAIpB,iBAAiB;;AAEjB;IACI;QACI,cAAc;IAClB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,mBAAmB;QACnB,gBAAgB;IACpB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;QACZ,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,gBAAgB;IACpB;IACA;;QAEI,iBAAiB;QACjB,eAAe;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,sCAAsC;IACtC,gDAAgD;AACpD;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,oCAAoC;IACpC,8CAA8C;AAClD;;AAEA;IACI,SAAS;IACT,UAAU;IACV,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,sCAAsC;IACtC,gDAAgD;AACpD;;;AAGA;IACI,OAAO;IACP,MAAM;IACN,UAAU;IACV,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,sCAAsC;IACtC,gDAAgD;AACpD;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,oCAAoC;IACpC,8CAA8C;AAClD;;AAEA;IACI,SAAS;IACT,UAAU;IACV,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,sCAAsC;IACtC,gDAAgD;AACpD;;;AAGA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":["\n\n.container {\n  display: block;\n  position: relative;\n  padding-left: 35px;\n  margin-bottom: 12px;\n  cursor: pointer;\n  font-size: 22px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n/* Hide the browser's default checkbox */\n.container input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n}\n\n/* Create a custom checkbox */\n.checkmark {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 25px;\n  width: 25px;\n  background-color: #eee;\n}\n\n/* On mouse-over, add a grey background color */\n.container:hover input ~ .checkmark {\n  background-color: #ccc;\n}\n\n/* When the checkbox is checked, add a blue background */\n.container input:checked ~ .checkmark {\n  background-color: #2196F3;\n}\n\n/* Create the checkmark/indicator (hidden when not checked) */\n.checkmark:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n\n/* Show the checkmark when checked */\n.container input:checked ~ .checkmark:after {\n  display: block;\n}\n\n/* Style the checkmark/indicator */\n.container .checkmark:after {\n  left: 9px;\n  top: 5px;\n  width: 5px;\n  height: 10px;\n  border: solid white;\n  border-width: 0 3px 3px 0;\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.new-button {\n        display: inline-block;\n    padding: 10px 10px;\n    cursor: pointer;\n    border: 1px solid #D9D9D9;\n    font-size: 14px;\n    color: #595D6E;\n}\n.button-wrap input[type=\"file\"] {\n  position: absolute;\n  z-index: -1;\n  top: 6px;\n  left: 0;\n  font-size: 15px;\n  color: rgb(153,153,153);\n}\n.button-wrap {\n  position: relative;display: flex;\n}\n.button-wrap button {\n    margin-left: 10px;\n}\n\n.new-csvbutton {\n        display: inline-block;\n    padding: 10px 10px;\n    cursor: pointer;\n    border: 1px solid #D9D9D9;\n    font-size: 14px;\n    color: #595D6E;\n    background: none;\n}\n\n\n\n\nhtml, body {\n    margin: 0;\n    padding: 0;\n    height: 100%;\n    min-height: 100%;\n}\n\n* {\n    box-sizing: border-box;\n}\n\n@import url('https://fonts.googleapis.com/css?family=Lato&display=swap');\n\nbody {\n    background-color: #f2f3f8;\n    margin: 0;\n    padding: 0px;\n    font-family: 'Lato', sans-serif;\n    font-size: 14px;\n    color: #464242;\n}\n\n::-webkit-scrollbar {\n    width: 6px;\n    height: 4px;\n}\n\n/* Track */\n\n::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 8px;\n}\n\n/* Handle */\n\n::-webkit-scrollbar-thumb {\n    background: #6399DD;\n    border-radius: 8px;\n    transition: all .3s;\n}\n\n/* Handle on hover */\n\n::-webkit-scrollbar-thumb:hover {\n    background: #6399DD;\n}\n\np, h1, h2, h3, h4, h5, h6 {\n    margin: 0px;\n}\n\nul {\n    list-style-type: none;\n    padding: 0px;\n    margin: 0px;\n}\n\nlabel {\n    display: block;\n}\n\n.dn {\n    display: none;\n}\n\n.db {\n    display: block;\n}\n\nbutton:focus {\n    outline: 0;\n}\n\n.text-center {\n    text-align: center;\n}\n\n.text-left {\n    text-align: left;\n}\n\n.text-right {\n    text-align: right;\n}\n\n.pd-20 {\n    padding: 20px;\n}\n\n.bg-grey {\n    background-color: #f2f3f8;\n}\n\n.pl-10 {\n    padding-left: 10px;\n}\n\n.pl-20 {\n    padding-left: 20px;\n}\n\n.mt-5 {\n    margin-top: 5px;\n}\n\n.m-0 {\n    margin: 0;\n}\n\n.mt-10 {\n    margin-top: 10px;\n}\n\n.mt-15 {\n    margin-top: 15px;\n}\n.ml-5 {\n    margin-left: 5px;\n}\n.ml-10 {\n    margin-left: 10px;\n}\n.ml-20 {\n    margin-left: 20px;\n}\n.ml-30 {\n    margin-left: 30px;\n}\n\n\n.mr-10 {\n    margin-right: 10px;\n}\n\n.mr-15 {\n    margin-right: 15px;\n}\n\n.ml-15 {\n    margin-left: 15px;\n}\n\n.mt-15 {\n    margin-top: 15px;\n}\n\n.mt-20 {\n    margin-top: 20px;\n}\n\n.mb-5 {\n    margin-bottom: 5px;\n}\n\n.mb-10 {\n    margin-bottom: 10px;\n}\n\n.mb-15 {\n    margin-bottom: 15px;\n}\n\n.mb-20 {\n    margin-bottom: 20px;\n}\n\n.mb-30 {\n    margin-bottom: 30px;\n}\n\n.mr-20 {\n    margin-right: 20px;\n}\n\n.wd-25 {\n    width: 25%;\n}\n\n.wd-20 {\n    width: 20%;\n}\n\n.wd-30 {\n    width: 30%;\n}\n\n.wd-35 {\n    width: 35%;\n}\n\n.wd-33 {\n    width: 33.333%;\n}\n\n.wd-40 {\n    width: 40%;\n}\n\n.wd-50 {\n    width: 50%;\n}\n.wd-60 {\n    width: 60%;\n}\n.wd-65 {\n    width: 65%;\n}\n\n.wd-66 {\n    width: 66.666%;\n}\n\n.wd-75 {\n    width: 75%;\n}\n\n.wd-70 {\n    width: 70%;\n}\n\n.wd-100 {\n    width: 100%;\n}\n.vh15{\n    height: 15vh;\n}\n.promize-badge {\n    padding: 4px 20px;\n    border-radius: 13px;\n    display: inline-block;\n}\n\n.promize-badge.badge-primary {\n    background-color: #011838;\n    color: #fff;\n}\n\n.promize-badge.badge-default {\n    background-color: #D6D9E4;\n    color: #3B3B3B;\n}\n\n.promize-badge-group li:not(:last-child) {\n    margin-right: 10px;\n}\n\ninput:disabled, select:disabled {\n    opacity: 0.4;\n}\n\n.promize-toggle {\n    display: flex;\n    align-items: center;\n}\n\n.promize-toggle>label:first-child {\n    margin-right: 10px;\n    color: #4c4646;\n    font-size: 13px;\n    font-family: \"Lato\";\n}\n\n.promize-toggle>label:first-child:empty {\n    display: none;\n}\n\n.promize-card-action.promize-toggle {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.toggle-aa {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n}\n\n.toggle-aa .tgl-btn {\n    margin-top: 20px;\n}\n\n.promize-left-sizebar {\n    width: 80px;\n    position: fixed;\n    height: 100%;\n    background-color: #011838;\n    z-index: 9;\n    transition: width .3s;\n}\n\n.promize-page-title-wrapper {\n    border-bottom: 1px solid #ddd;\n    padding-bottom: 5px;\n    margin-bottom: 20px;\n}\n\n.promize-page-title {\n    font-weight: normal;\n    font-size: 24px;\n}\n\n.promize-left-sizebar:hover {\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);\n    width: 190px;\n}\n\n.promize-card {\n    background-color: #fff;\n    border-radius: 0;\n    -webkit-box-shadow: 0 0 13px 0 rgba(82, 63, 105, .05);\n    box-shadow: 0 0 13px 0 rgba(82, 63, 105, .05);\n}\n\n.promize-container-fuild {\n    padding: 20px;\n}\n\n.promize-logo-lg img {\n    width: 200px;\n}\n\n.promize-logo {\n    text-align: center;\n    margin: 20px 0px;\n    width: 100%;\n}\n\n.promize-logo img {\n    max-width: 40px;\n}\n\n.promize-menu-items {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    margin-left: 10px;\n    overflow: hidden;\n}\n\n.promize-form-group {\n    position: relative;\n    margin-bottom: 25px;\n}\n\n.promize-action-list .rule-action-item .wd-30:nth-child(4) .promize-form-group {\n    width: 163px;\n}\n\n.promize-form-control {\n    display: block;\n    width: 100%;\n    padding: 5px 10px;\n    height: 40px;\n    font-size: 14px;\n    font-family: \"Lato\";\n    line-height: 34px;\n    color: #595D6E;\n    background-color: #fff;\n    background-image: none;\n    border: 0;\n    border: 1px solid #D9D9D9;\n    border-radius: 3px;\n    box-shadow: none;\n    transition: border-color ease-in-out .15s;\n}\n\ntextarea.promize-form-control {\n    height: auto;\n    width: 100% !important;\n}\n\n.promize-form-error {\n    font-size: 11px;\n    position: absolute;\n    bottom: -15px;\n    color: #FF5722;\n}\n.promize-form-info {\n    font-size: 11px;\n    position: absolute;\n    bottom: -17px;\n    left: 0;\n}\n.promize-form-info>i {\n    margin-right: 5px;\n}\n.promize-form-control:focus {\n    outline: 0;\n    border-color: #2F89F9;\n}\n\n.promize-form-group .promize-form-control-label {\n    margin-bottom: 6px;\n    color: #4c4646;\n    font-size: 13px;\n    font-family: \"Lato\";\n}\n\n.promize-form-addon {\n    display: flex;\n    align-items: flex-end;\n}\n\n.promize-picker {\n    width: 50px;\n    height: 40px;\n    border: 1px solid #d9d9d9;\n    border-top-right-radius: 3px;\n    border-bottom-right-radius: 3px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n}\n\n.promize-picker img {\n    max-width: 20px;\n}\n\n.sketch-picker {\n    width: 170px !important;\n}\n\n.sketch-picker>div:first-child {\n    padding-bottom: 45% !important;\n}\n\n.sketch-picker>div:last-child {\n    display: none !important;\n}\n\n.promize-picker-control {\n    width: 100%;\n}\n\n.promize-picker-control .promize-form-control {\n    border-right: 0;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.promize-menu-items>li {\n    margin-bottom: 8px;\n}\n\n.promize-sizebar-item a {\n    text-decoration: none;\n    color: #778088;\n    padding: 20px;\n    padding-left: 10px;\n    width: 70px;\n    height: 60px;\n    border-left: 5px solid transparent;\n    border-radius: 4px 0px 0px 4px;\n    padding-right: 0px;\n    display: flex;\n    align-items: center;\n    transition: all .3s;\n}\n\n.promize-left-sizebar:hover .promize-sizebar-item a {\n    width: 180px;\n}\n.promize-left-sizebar:hover .promize-sizebar-item a:hover {\n    background-color: rgba(255, 255, 255, 0.1);\n    color: #a5adb5;\n}\n.promize-sidebar-links.active {\n    border-radius: 4px 0px 0px 4px;\n    background: linear-gradient(to right, #162a45 0%, #011838 100%);\n    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.39);\n    border-left: 5px solid #2F89F9;\n    color: #fff;\n}\n\n.promize-sizebar-item a i {\n    font-size: 18px;\n    margin: 0px 8px;\n}\n\n.promize-sizebar-item a>div {\n    display: flex;\n    align-items: center;\n}\n\n.promize-sizebar-item a>div>span {\n    opacity: 0;\n    transition: opacity .3s;\n    margin-left: 12px;\n    white-space: nowrap;\n}\n\n.promize-left-sizebar:hover .promize-sizebar-item a>div>span {\n    opacity: 1;\n}\n\n.promize-sizebar-item.active a i {\n    color: #fff;\n}\n\n.promize-main-wrapper {\n    display: flex;\n    flex-flow: row;\n}\n\n.promize-page-wrapper {\n    width: 100%;\n    margin-left: 80px;\n}\n\n.promize-table {\n    width: 100%;\n    border-spacing: 0;\n    border-collapse: collapse;\n}\n\n.promize-table thead tr th, .promize-table tbody tr td {\n    padding: 10px 10px;\n    font-size: 14px;\n    font-family: Lato;\n}\n\n.promize-table thead tr {\n    border-bottom: 0;\n    height: 40px;\n    color: #fff;\n    font-size: 18px;\n}\n\n.promize-table thead tr th {\n    background-color: #EBEDF2;\n    font-weight: bold;\n    font-size: 14px;\n    text-align: left;\n    color: #434863;\n    padding: 16px 10px;\n}\n\n.promize-table tbody {\n    border-bottom: 1px solid #eeeeee;\n}\n\n.promize-table tbody tr {\n    border-bottom: 1px solid #eeeeee;\n    height: 35px;\n}\n\n.promize-table tbody tr td {\n    font-weight: 500;\n    font-size: 14px;\n    text-align: left;\n    color: #464242;\n    font-weight: 400;\n    transition: all .1s;\n}\n\n.promize-table tbody tr td:not(.option-code):first-letter {\n    text-transform: uppercase;\n}\n\n.promize-table tbody tr:nth-child(even) td {\n    background-color: #f9f9f9;\n}\n\n.table-hover tbody tr:hover td {\n    background-color: rgba(1, 24, 56, 0.04);\n}\n\n.table-action thead tr th:last-child, .table-action thead tr th:nth-last-child(2) {\n    width: 160px;\n}\n\n.promize-table.table-action thead tr th:last-child, .promize-table.table-action tbody tr td:last-child {\n    text-align: center;\n}\n\n.promize-table th.sorting::after {\n    content: \"\\f0dc\";\n    font-family: 'Font Awesome 5 Free';\n    margin-left: 8px;\n    color: #abafc2;\n}\n\n.promize-table th.sorting-asec::after {\n    content: \"\\f0de\";\n    font-family: 'Font Awesome 5 Free';\n    margin-left: 8px;\n    color: #5584c7;\n    font-size: 16px;\n}\n\n.promize-table th.sorting-desc::after {\n    content: \"\\f0dd\";\n    font-family: 'Font Awesome 5 Free';\n    margin-left: 8px;\n    color: #5584c7;\n    font-size: 16px;\n}\n\n.promize-table.table-options thead tr th {\n    background-color: transparent;\n}\n\n.promize-table.table-options tbody tr td {\n    background-color: #fff;\n}\n\n.promize-table.table-options {\n    border-spacing: 0px 12px;\n    border-collapse: separate;\n    margin-top: -12px;\n}\n\n.table-options.table-action thead tr th:last-child {\n    width: 120px;\n}\n\n.promize-table.table-options thead tr th {\n    padding: 5px 10px;\n}\n\n.promize-table.table-options tbody tr {\n    overflow: hidden;\n    border-radius: 5px;\n    border: 0;\n    box-shadow: 0 0 13px rgba(82, 63, 105, 0.10);\n}\n\n.promize-table.table-options tbody tr td:first-child {\n    border-top-left-radius: 5px;\n    border-bottom-left-radius: 5px;\n}\n\n.promize-table.table-options tbody tr td:last-child {\n    border-top-right-radius: 5px;\n    border-bottom-right-radius: 5px;\n}\n\n.promize-card-header {\n    padding: 0px 20px;\n    display: flex;\n    justify-content: space-between;\n    position: relative;\n}\n.promize-attr-dup-text {\n    position: absolute;\n    top: 4px;\n    left: 50%;\n    transform: translateX(-50%);\n    text-align: center;\n    padding: 5px 10px;\n    background-color: rgba(0, 173, 29, 0.1);\n    color: #007313;\n    border-radius: 5px;\n    font-size: 14px;\n}\n.promize-card-innerheader {\n    padding: 0px;\n    border-bottom: 1px solid #d9d9d9;\n    margin-bottom: 20px;\n}\n\n.promize-card-title h3 {\n    margin-top: 16px;\n}\n\n.promize-card-title {\n    display: flex;\n    align-items: baseline;\n    justify-content: center;\n    flex-wrap: wrap;\n    flex-direction: column;\n}\n\n.promize-card-innerheader h3 {\n    margin-top: 0;\n}\n\n.promize-card-subtitle {\n    font-size: 13px;\n}\n\n.promize-title-subtitle {\n    font-size: 12px;\n    color: #9e9e9e;\n}\n\n.promize-card-title h3 span {\n    font-size: 16px;\n    text-transform: capitalize;\n    color: #011838;\n}\n\n.promize-card-innertitle h3 span {\n    font-size: 18px;\n    text-transform: capitalize;\n    color: #011838;\n}\n\n.promize-card-body {\n    padding: 20px;\n    min-height: 15vh;\n}\n\n.promize-footer-actions {\n    text-align: right;\n    padding: 0px 20px 20px;\n}\n\n.promize-card-action {\n    width: 40%;\n    max-width: 400px;\n    display: flex;\n    margin-top: 20px;\n    justify-content: space-between;\n}\n\n.promize-sm-card-action {\n    width: 30%;\n    max-width: 350px;\n    display: flex;\n    margin-top: 10px;\n    justify-content: space-between;\n}\n\n.search-container+.btn {\n    margin-left: 10px;\n    width: 160px;\n}\n\n.promize-card-innerheader .promize-card-action {\n    margin: 5px 0px;\n}\n\n.search-container {\n    position: relative;\n    width: 100%;\n}\n\n.search-container i {\n    position: absolute;\n    top: 14px;\n    color: #d9d9d9;\n    left: 12px;\n}\n\n.search-container .promize-form-control {\n    padding-left: 40px;\n    font-weight: normal;\n}\n.promize-product-add {\n    width: unset;\n    max-width: unset;\n}\n\n.promize-product-add .btn {\n    width: 150px;\n}\n\n.promize-product-add .search-container {\n    max-width: 240px;\n}\n.df {\n    display: flex;\n}\n\n.df-wrap {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.df-end {\n    justify-content: flex-end;\n}\n\n.df-flow {\n    display: flex;\n    flex-flow: row;\n    flex-wrap: wrap\n}\n\n.df-sp-btwn {\n    display: flex;\n    justify-content: space-between;\n}\n\n.df-sp-around {\n    display: flex;\n    justify-content: space-around;\n}\n\n.df-al-center {\n    display: flex;\n    align-items: center;\n}\n\n.df-js-center {\n    display: flex;\n    justify-content: center;\n}\n\n.df-al-cen {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.btn {\n    font-family: 'Lato', sans-serif;\n    font-size: 15px;\n    text-transform: capitalize;\n    border: 0;\n    box-shadow: none;\n    height: 40px;\n    padding: 10px 10px;\n    min-width: 90px;\n    box-shadow: none;\n    border-radius: 2px;\n    cursor: pointer;\n    display: inline-block;\n    background-color: transparent;\n    border: 1px solid transparent;\n    text-align: center;\n    text-decoration: none;\n    transition: all .3s;\n}\n\n.txt-captls {\n    text-transform: capitalize;\n}\n\n.btn:focus {\n    outline: 0;\n}\n\n.btn-promize-primary {\n    border: 1px solid #2F89F9;\n    background-color: #2F89F9;\n    color: #fff;\n}\n.btn-promize-primary+.btn-promize-primary{\n    margin-left: 10px;\n}\n.btn-promize-secondary {\n    background-color: #fff;\n    color: #6b6e82;\n    border: 1px solid #6b6e82;\n    margin-right: 10px;\n}\n\n.btn-promize-primary:hover{\n    background-color: #034394;\n    border: 1px solid #034394;\n}\n.btn-promize-secondary:hover {\n    color: #fff;\n    border: 1px solid #6b6e82;\n    background-color: #6b6e82;\n}\n\n.btn-links {\n    font-size: 13px;\n    color: #2F89F9;\n}\n\n.btn-tbl {\n    display: inline-block;\n    font-size: 14px;\n    border: 0;\n    box-shadow: none;\n    height: 36px;\n    width: 36px;\n    line-height: 36px;\n    padding: 0px 5px;\n    border: 0;\n    background-color: #ffffffd9;\n    box-shadow: none;\n    cursor: pointer;\n    color: #777b92;\n    border-radius: 5px;\n    transition: all .3s;\n    border: 1px solid #eaeaea;\n}\n\n.btn-tbl+.btn-tbl {\n    margin-left: 15px;\n}\n\n.btn-tbl:hover {\n    box-shadow: 0 4px 10px rgba(1, 24, 56, 0.25);\n}\n\n.btn-links:hover {\n    background-color: #eff2fe;\n}\n\n.promize-pagination ul {\n    display: flex;\n}\n\n.promize-pagination ul li:not(:last-child) {\n    margin-right: 8px;\n}\n\n.promize-pagination ul li button {\n    color: #5660a2;\n    float: left;\n    text-decoration: none;\n    height: 32px;\n    width: 34px;\n    padding-bottom: 1px;\n    font-size: 13px;\n    box-shadow: none;\n    border: none;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 2px;\n    transition: .3s;\n    cursor: pointer;\n}\n\n.promize-pagination ul li button.active {\n    background-color: #2f89f9;\n    color: white;\n}\n\n.promize-pagination ul li:first-child button, .promize-pagination ul li:last-child button, .promize-pagination ul li:nth-child(2) button, .promize-pagination ul li:nth-last-child(2) button {\n    background-color: #ebedf2;\n}\n\n.promize-pagination ul li button:hover {\n    background-color: #3b7cf8;\n    color: #fff;\n}\n\n.promize-pagination ul li.disabled button {\n    opacity: .4;\n    cursor: not-allowed;\n    pointer-events: none;\n}\n\n.table-footer-action {\n    display: flex;\n    justify-content: space-between;\n    margin: 20px 0px 5px;\n}\n\n.promize-entries {\n    display: flex;\n    align-items: center;\n}\n\n.promize-entries p {\n    color: #6a6e84;\n    font-size: 12px;\n}\n\n.df-end .check-mainbox {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.select-control {\n    background-color: rgba(93, 120, 255, 0.1);\n    border: 0;\n    box-shadow: none;\n    border-radius: 0;\n    color: #2F89F9;\n    font-weight: bold;\n    width: 70px;\n}\n\n.promize-entries .select-control {\n    height: 30px;\n}\n\n.promize-info-text {\n    font-size: 13px;\n    color: #999;\n}\n\n.promize-info-text a {\n    color: #2F89F9;\n    text-decoration: underline;\n}\n\n.tgl {\n    display: none;\n}\n\n.tgl+.tgl-btn {\n    outline: 0;\n    display: block;\n    width: 50px;\n    height: 26px;\n    position: relative;\n    cursor: pointer;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    user-select: none;\n}\n\n.tgl+.tgl-btn:hover {\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.36);\n}\n\n.tgl+.tgl-btn:after, .tgl+.tgl-btn:before {\n    position: relative;\n    display: block;\n    content: \"\";\n    width: 20px;\n    height: 20px;\n}\n\n.tgl+.tgl-btn:after {\n    left: 1px;\n}\n\n.tgl+.tgl-btn:before {\n    display: none;\n}\n\n.tgl:checked+.tgl-btn:after {\n    left: calc(50% + 1px);\n    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);\n}\n\n.tgl-light+.tgl-btn {\n    background: #9E9E9E;\n    border-radius: 2em;\n    padding: 3px;\n    transition: all .4s ease;\n}\n\n.tgl-light+.tgl-btn:after {\n    border-radius: 50%;\n    background: #fff;\n    transition: all .2s ease;\n}\n\n.tgl-light:checked+.tgl-btn {\n    background: #3c9ece;\n    background: linear-gradient(45deg, #2f89f9, rgba(47, 137, 249, 0.7));\n}\n\n.multi_select_option {\n    padding: 10px\n}\n\n.multi_select_option:hover {\n    background-color: #dee7fe\n}\n\n.multi_select_option .multi_select_sub_label {\n    font-size: 10px;\n}\n\n.promize-customizer {\n    width: 100%;\n    background-color: #fff;\n    height: 100vh;\n    text-align: left;\n}\n\n.promize-inncustomizer {\n    padding: 30px;\n}\n\n.promize-buttons {\n    text-align: right;\n}\n\n.promize-attr-title {\n    color: #011838;\n    font-size: 15px;\n    margin-bottom: 15px;\n}\n\nlabel sup {\n    color: #F44336;\n    font-size: 13px;\n    height: 5px;\n    line-height: 5px;\n}\n\n.promize.add-field {\n    margin: 0;\n    display: inline-block;\n    border-radius: 5px;\n    border: 2px solid #2e88f9;\n    height: 155px;\n    margin-left: 20px;\n    padding: 10px;\n    box-shadow: 4px 3px 15px 3px rgba(145, 145, 145, 0.89);\n    margin-left: 20px;\n    margin-top: 20px;\n}\n\n.edit i.fa.fa-pencil-square-o {\n    border: 1px solid #27c527;\n    padding: 10px;\n    margin: 10px;\n    color: #27c527;\n    border-radius: 2px;\n}\n\n.edit i.fa.fa-trash {\n    color: red;\n    border: 1px solid red;\n    padding: 10px;\n    border-radius: 2px;\n}\n\n.promize-uplaod {\n    text-align: center;\n}\n\n.promize-sticky-20 {\n    position: sticky;\n    top: 20px;\n    align-self: flex-start;\n}\n\n.promize-set-position {\n    /* padding-right: 20px; */\n}\n\n.promize-set-position>button {\n    background-color: transparent;\n    border: none;\n    box-shadow: none;\n    font-size: 16px;\n    text-decoration: underline;\n}\n\n.promize-widget .promize-widget {\n    border: 1px solid #E8E8E8;\n}\n\n.promize-widget .promize-widget.promize-subtab {\n    border-left: 5px solid #2e89f9;\n}\n\n.promize-modal-cover, .promize-modal-cover-delete-popup, .promize-modal-cover-tab-selection, .promize-modal-cover-set-postion {\n    position: fixed;\n    background-color: rgba(0, 0, 0, 0.6);\n    height: 100%;\n    width: 100%;\n    top: 0;\n    left: 0;\n    z-index: 9;\n    overflow: auto;\n}\n\n.promize-modal.modal-sm, .promize-modal-cover-delete-popup.modal-sm, .promize-modal-cover-tab-selection.modal-sm, .promize-modal-cover-set-postion.modal-sm {\n    position: relative;\n    max-width: 35%;\n    background-color: #fff;\n    padding: 0;\n    left: 0;\n    right: 0;\n    border-radius: 5px;\n    overflow: hidden;\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);\n    -webkit-transform: translate(0, 0);\n    -ms-transform: translate(0, 0);\n    -o-transform: translate(0, 0);\n    transform: translate(0, 0);\n    margin: 30px auto;\n}\n\n.promize-modal.modal-lg {\n    position: relative;\n    max-width: 70%;\n    background-color: #fff;\n    padding: 0;\n    left: 0;\n    top: 0;\n    right: 0;\n    border-radius: 5px;\n    overflow: hidden;\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);\n    -webkit-transform: translate(0, 0);\n    -ms-transform: translate(0, 0);\n    -o-transform: translate(0, 0);\n    transform: translate(0, 0);\n    margin: 30px auto;\n}\n\n.promize-modal.modal-md {\n    position: relative;\n    max-width: 50%;\n    background-color: #fff;\n    padding: 0;\n    left: 0;\n    top: 0;\n    right: 0;\n    border-radius: 5px;\n    overflow: hidden;\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);\n    -webkit-transform: translate(0, 0);\n    -ms-transform: translate(0, 0);\n    -o-transform: translate(0, 0);\n    transform: translate(0, 0);\n    margin: 30px auto;\n}\n\n.promize-modal-header {\n    padding: 14px 0px 14px 20px;\n    background-color: #F7F7F7;\n    border-bottom: 1px solid #d9d9d9;\n}\n\n.modal-close {\n    position: absolute;\n    right: 5px;\n    top: 5px;\n    border: 0;\n    padding: 10px 15px;\n    background-color: transparent;\n    font-size: 15px;\n    color: #3C3C3C;\n    cursor: pointer;\n}\n\n.promize-modal-body {\n    padding: 15px;\n    background-color: #fff;\n}\n\n.promize-modal-footer {\n    background-color: #fff;\n    padding: 15px;\n    padding-top: 0px;\n}\n.promize-modal-footer .previous{\n    background: white;\n    border: 1px solid black;\n    height: 40px;\n    margin-right: 1rem;\n    padding: 0 1rem;\n    cursor: pointer;\n}\n\n.promize-modal-footer .next{\n    background: white;\n    border: 1px solid black;\n    height: 40px;\n    margin-right: 1rem;\n    padding: 0 1rem;\n    cursor: pointer;\n}\n.modal-title {\n    font-size: 18px;\n    color: #464457;\n    font-weight: normal;\n    font-family: \"Lato\";\n}\n\n.btn-modal-close {\n    float: right;\n    margin-top: -25px;\n    margin-right: 10px;\n    padding: 5px 10px;\n    font-size: 15px;\n    border: none;\n    box-shadow: none;\n    background-color: transparent;\n    cursor: pointer;\n    color: #464457;\n}\n.promize-link-thumb{\n    max-width: 40px;\n    max-height: 26px;\n}\n.promize-upload-header {\n    position: relative;\n    margin-bottom: 8px;\n}\n\n.promize-upload {\n    background-color: #fff;\n}\n\n.promize-upload:focus {\n    outline: 0;\n}\n\n.promize-upload-title {\n    font-size: 13px;\n    font-family: \"Lato\";\n    font-weight: normal;\n    color: #4c4646;\n}\n\n.promize-upload-button {\n    font-family: \"Lato\";\n    font-size: 13px;\n    padding: 0px;\n    color: #2f89f9;\n    position: relative;\n    cursor: pointer;\n}\n\n.promize-content-before-upload>img {\n    max-width: 90px;\n    max-height: 90px;\n}\n\n.promize-prdt-section-list {\n    display: flex;\n    max-width: calc(100% - 130px);\n    overflow: auto hidden;\n}\n\n.promize-prdt-section-container {\n    position: relative;\n    border-bottom: 1px solid #D0D0D0;\n}\n.promize-prdt-section-container .pormize-abs-rght .btn-links:hover{\n    background-color: #e4e4e4;\n}\n.promize-content-before-upload {\n    text-align: center;\n}\n\n.promize-upload-content {\n    padding: 10px;\n    border: 1px solid #d9d9d9;\n    border-radius: 5px;\n    min-height: 165px;\n    transition: all .3s;\n    cursor: pointer;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.promize-upload-content.promize-multi-upload-cover {\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n.promize-upload-sm .promize-upload-content {\n    height: 80px;\n    min-height: 80px;\n    display: flex;\n    border-style: dashed;\n    border-color: #9e9e9e;\n    align-items: center;\n    justify-content: center;\n    padding: 5px;\n    color: #716f6f;\n}\n\n.promize-upload-sm .promize-upload-content p {\n    margin-top: 6px;\n}\n\n.promize-upload-sm .promize-content-after-upload img {\n    max-width: 60px;\n    max-height: 60px;\n}\n\n.custom-upload-product img {\n    max-width: 200px;\n    margin-bottom: 10px;\n}\n\n.custom-upload-product {\n    position: absolute;\n    top: 0px;\n    right: 0px;\n}\n\n.custom-upload-product input {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    height: 100%;\n    width: 100%;\n    opacity: 0;\n    cursor: pointer;\n}\n.promize-upload-content.promize-multi-upload-cover .promize-content-before-upload{\n    align-items: center;\n    width: 100%;\n    margin-top: 20px;\n}\n.promize-upload-content .react-sweet-progress{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: calc(100% + 2px);\n    position: absolute;\n    height: calc(100% + 2px);\n    top: -1px;\n    left: -1px;\n    background-color: rgba(255, 255, 255, 0.8);\n    padding: 20px;\n    border-radius: 4px;\n}\n.promize-upload-content .react-sweet-progress-line {\n    width: 100%;\n    border-radius: 6px;\n    height: 6px;\n    background-color: rgb(231, 230, 230);\n    vertical-align: middle;\n}\n.promize-upload-content .react-sweet-progress-line-inner {\n    position: relative;\n    min-height: 6px;\n    border-radius: 6px;\n    transition: width 0.3s ease;\n}\n.promize-upload-content .react-sweet-progress-symbol\n{\n    display: none;\n}\n.promize-display-items>label:not(:last-child) {\n    margin-right: 10px;\n}\n\n.promize-display-items {\n    display: flex;\n    flex-wrap: nowrap;\n}\n\n.promize-display-set {\n    padding-left: 30px;\n    margin-left: 30px;\n    border-left: 1px dashed #9e9e9e;\n}\n\n.promize-display-set .promize-form-group {\n    margin-bottom: 0;\n    margin-top: 10px;\n}\n.promize-display-set .check-mainbox\n{\n    margin-top: 10px;\n}\n.promize-display-set .check-mainbox .toggle-aa .tgl-btn{\n    margin-top: 15px;\n}\n.promize-dragable-tab-container>.promize-widget {\n    cursor: grab;\n    transition: all .3s;\n}\n\n.promize-dragable-tab-container>.promize-widget:hover {\n    box-shadow: 0 5px 10px #01183726;\n}\n\n.tab-drag-empty {\n    height: 50px;\n    border: 1px dashed #2f89f9;\n    margin-bottom: 20px;\n}\n\n.promize-dragable-list>li {\n    cursor: grab;\n}\n\n.promize-sticky-20 .promize-dragable-container {\n    max-height: 60vh;\n    overflow-y: auto;\n    padding-right: 5px;\n}\n\n.dragable-items {\n    border: 1px solid #e8e8e8;\n    border-radius: 3px;\n    overflow: hidden;\n    transition: all .3s;\n}\n\n.option-name {\n    color: #464242;\n    position: relative;\n    text-transform: capitalize;\n    padding-top: 5px;\n    padding-bottom: 5px;\n    font-size: 12px;\n}\n\n.promize-widget-sub-title>i:first-child {\n    font-size: 20px;\n}\n\n.promize-widget-sub-title {\n    text-transform: capitalize;\n}\n\n.option-name>i, .promize-widget-sub-title>i:first-child {\n    color: #f12e61;\n    margin-right: 10px;\n    font-size: 14px;\n}\n\n.option-name>a {\n    position: absolute;\n    right: 8px;\n    top: 9px;\n    height: 20px;\n    width: 20px;\n    text-align: center;\n    padding: 2px;\n    font-size: 13px;\n    color: #a7abc3;\n    transition: all .3s;\n    display: none;\n}\n\n.promize-dragable-list>li:hover .dragable-items {\n    background-color: #f5f5f5;\n}\n.promize-dragable-list>li.active {\n    background-color: #2F89F9;\n}\n\n.promize-dragable-list>li:hover .option-name>a {\n    display: block;\n}\n\n.option-action {\n    position: relative;\n}\n\n.option-btn {\n    padding: 12px 8px 10px 12px;\n    border: 0;\n    color: #9E9E9E;\n    background-color: transparent;\n    cursor: grab;\n    font-size: 12px;\n    position: relative;\n    margin-right: 5px;\n    display: flex;\n}\n\n/* .option-btn:after {\n    position: absolute;\n    content: \"\";\n    width: 1px;\n    height: 15px;\n    top: 0;\n    right: 2px;\n    bottom: 0;\n    margin: auto;\n    background-color: #d9d9d9;\n} */\n\n.promize-tag-items li {\n    display: inline-block;\n}\n\n.promize-tags {\n    padding: 10px 20px;\n    background-color: #373b5f;\n    color: #fff;\n    font-size: 16px;\n    border-radius: 7px;\n}\n\n.promize-tags .remove-tag {\n    cursor: pointer;\n}\n\n.promize-widget {\n    position: relative;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    min-width: 0;\n    word-wrap: break-word;\n    background-color: #fff;\n    background-clip: border-box;\n    border-radius: 3px;\n    /* -webkit-box-shadow: 0 0 13px 0 rgba(82,63,105,.05);\n    box-shadow: 0 0 13px 0 rgba(82,63,105,.05); */\n}\n\n.promize-widget-header {\n    padding: 10px 15px;\n    padding-left: 24px;\n    margin-bottom: 0;\n    background-color: #FFFFFF;\n    display: flex;\n    justify-content: flex-start;\n    height: 50px;\n    position: relative;\n}\n\n.promize-drag-icon-vi {\n    font-size: 13px;\n    display: flex;\n    align-items: center;\n    position: absolute;\n    left: 8px;\n    top: 18px;\n    color: #a6abc3;\n    opacity: 0;\n    visibility: hidden;\n    transition: all .2s;\n}\n\n.promize-widget-header:hover>.promize-drag-icon-vi {\n    opacity: 1;\n    visibility: visible;\n}\n.promize-sec-list>li.active {\n    background-color: #2F89F9;\n    border-radius: 5px;\n    overflow: visible;\n}\n\n.promize-sec-list>li .dragable-items {\n    display: flex;\n    align-items: center;\n    padding: 0px 0px 0px 10px;\n    overflow: visible;\n    font-size: 12px;\n}\n\n.promize-sec-list>li .dragable-items .btn {\n    margin-left: auto;\n    width: 30px;\n    height: 32px;\n    border: 0;\n    background-color: transparent;\n    color: #a7a4a4;\n    font-size: 12px;\n}\n\n.promize-sec-list>li.active .dragable-items {\n    color: #fff;\n}\n\n.promize-sec-list>li.active:hover .dragable-items {\n    background-color: transparent;\n}\n\n.promize-sec-list>li .dragable-items .btn:hover {\n    box-shadow: none;\n}\n\n.promize-sec-list>li .dragable-items .btn .promize-btn-description {\n    min-width: 80px;\n    padding-top: 2px;\n}\n\n\n.promize-sec-list>li.active .dragable-items .btn {\n    color: #f1eded;\n}\n\n.promize-sec-icon .promize-upload {\n    background-color: transparent;\n    min-width: 85px;\n\n}\n\n.promize-sec-icon .promize-upload .promize-upload-content {\n    background-color: #fff;\n}\n.promize-widget-title {\n    display: flex;\n    align-items: center;\n    font-size: 15px;\n    color: #011838;\n    font-weight: normal;\n}\n\n.promize-sub-content {\n    color: #939393;\n    font-size: 12px;\n}\n\n.promize-widget-action {\n    margin-left: auto;\n    margin-right: 30px;\n}\n\n.promize-widget-action>ul>li+li {\n    margin-left: 15px;\n}\n\n.promize-widget-body {\n    padding: 15px;\n    border-top: 1px solid #E8E8E8;\n}\n\n.promize-tab-options {\n    display: flex;\n    flex-wrap: wrap;\n    padding: 0px;\n}\n\n.promize-tab-options li {\n    display: block;\n    padding: 0px;\n}\n.portlet-menu>li {\n    width: 100%;\n}\n.portlet-menu li+li {\n    border-left: 1px solid #DAD9DD;\n}\n\n.promize-tab-options-detail {\n    width: 250px;\n    border-radius: 5px;\n    display: flex;\n    flex-direction: column-reverse;\n    transition: all .2s;\n    box-shadow: 0 0 10px rgba(82, 63, 105, .15);\n}\n.promize-tab-options-detail:hover {\n    box-shadow: 0 0 10px rgba(82, 63, 105, .3);\n}\n.promize-drop-attr {\n    width: 100%;\n    height: 70px;\n    border: 2px dashed #2f89f9;\n    background-color: #FCFCFC;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #2f89f9;\n    font-size: 14px;\n    transition: all .2s;\n}\n\n.promize-upload-content.promize-highlight {\n    border-color: #2F89F9;\n    box-shadow: 0 0 2px 6px rgba(47, 137, 249, 0.3);\n}\n\n.promize-drop-attr.promize-highlight {\n    border: 0;\n    background-color: rgba(47, 137, 249, 0.16);\n    color: #011838;\n    font-weight: bold;\n    background-image: linear-gradient(90deg, #011838 50%, transparent 50%), linear-gradient(90deg, #011838 50%, transparent 50%), linear-gradient(0deg, #011838 50%, transparent 50%), linear-gradient(0deg, #011838 50%, transparent 50%);\n    background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;\n    background-size: 15px 2px, 15px 2px, 2px 15px, 2px 15px;\n    background-position: left top, right bottom, left bottom, right top;\n    animation: border-animate .2s infinite linear;\n}\n@keyframes border-animate {\n    0% {\n      background-position: left top, right bottom, left bottom, right   top;\n    }\n    100% {\n      background-position: left 15px top, right 15px bottom , left bottom 15px , right   top 15px;\n    }\n  }\n.tab-option-container {\n    padding: 15px 10px 10px;\n    min-height: 200px;\n    position: relative;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.promize-tab-options-detail .tab-option-container img {\n    max-width: 180px;\n    max-height: 180px;\n}\n\n.promize-widget .promize-tab-options li {\n    width: 100%;\n}\n\n.promize-widget .promize-tab-options-detail {\n    width: 100%;\n    border-radius: 2px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.promize-widget .tab-option-container {\n    min-height: unset;\n}\n\n.promize-widget .tab-option-container img {\n    max-width: 100px;\n    max-height: 100px;\n}\n\n.tab-options-prop {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    bottom: -100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    padding: 10px 15px;\n    opacity: 0;\n    visibility: hidden;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    transition: all .3s;\n}\n\n.tab-options-prop .tab-option-title {\n    color: #fff;\n    font-weight: bold;\n}\n\n.tab-option-container:hover .tab-options-prop {\n    bottom: 0;\n    opacity: 1;\n    visibility: visible;\n}\n\n.promize-widget .btn {\n    min-width: auto;\n    height: 30px;\n    line-height: 30px;\n    position: relative;\n}\n\n.promize-widget .promize-upload-edit {\n    display: none;\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    box-shadow: none;\n    background-color: #f1f2f7;\n    line-height: normal !important;\n    padding: 0px 8px;\n    color: #3b3b3b;\n    border-radius: 4px;\n}\n\n.promize-upload:hover .promize-upload-edit {\n    display: block;\n}\n\n.promize-widget .promize-widget-header .btn {\n    background-color: transparent;\n    margin-left: 5px;\n    width: auto;\n    font-size: 13px;\n    margin-left: 0px;\n    padding: 0px 0px;\n    min-width: 30px;\n    border-radius: 0;\n    border: 0;\n    font-weight: normal;\n    color: #64677b;\n    border-radius: 16px;\n    position: relative;\n}\n\n.promize-widget .promize-widget-header .btn:hover {\n    box-shadow: none;\n    background-color: #ddddde;\n}\n\n.promize-widget .promize-widget-header .btn .clr-bl {\n    color: #35649e;\n}\n\n.promize-widget-sub-title {\n    font-size: 13px;\n    font-weight: normal;\n    color: #011838;\n}\n\n.promize-widget .promize-widget-header .btn:hover {\n    box-shadow: none;\n}\n\n.btn .promize-btn-description,.btn-prop-lock .promize-btn-description {\n    font-weight: normal;\n    font-size: 11px;\n    position: absolute;\n    bottom: 40px;\n    left: 50%;\n    min-width: 130px;\n    background-color: #4e4e4e;\n    color: #fff;\n    border-radius: 5px;\n    box-shadow: 0 5px 10px rgba(82, 63, 105, 0.2);\n    min-height: 27px;\n    line-height: 25px;\n    padding: 0px 5px;\n    opacity: 0;\n    visibility: hidden;\n    -webkit-transform: translate(-50%,10px);\n    -moz-transform: translate(-50%,10px);\n    -ms-transform: translate(-50%,10px);\n    -o-transform:translate(-50%,10px);\n    transform: translate(-50%,10px);\n    -webkit-transition: all .25s ease-out;\n    -moz-transition: all .25s ease-out;\n    -ms-transition: all .25s ease-out;\n    -o-transition: all .25s ease-out;\n    transition: all .25s ease-out;\n}\n\n.btn:hover .promize-btn-description,.btn-prop-lock:hover .promize-btn-description {\n    filter: alpha(opacity=100);\n    opacity: 1;\n    visibility: visible;\n    -webkit-transform: translate(-50%,0px);\n    -moz-transform: translate(-50%,0px);\n    -ms-transform: translate(-50%,0px);\n    -o-transform: translate(-50%,0px);\n    transform: translate(-50%,0px);\n}\n\n.btn:hover .promize-btn-description:after {\n    border: 10px solid transparent;\n    border-bottom: 0;\n    border-top: 10px solid #4e4e4e;\n    position: absolute;\n    content: \"\";\n    left: 50%;\n    bottom: -6px;\n    transform: translateX(-50%);\n}\n\n.promize-widget .promize-widget-header .promize-widget-toggle .btn {\n    line-height: 0;\n    color: #64677b;\n}\n\n.promize-widget .promize-widget-header .promize-widget-toggle .btn:hover {\n    background-color: #f2f3f8;\n}\n\n.promize-widget-toggle .btn.toggle {\n    transform: rotate(90deg);\n}\n\n.promize-widget .tab-option-actions .btn {\n    color: #373b5f;\n}\n\n.promize-widget-drag {\n    position: absolute;\n    right: 50px;\n    top: 8px;\n    color: #a7abc3;\n}\n\n.promize-widget-drag .btn {\n    color: #a7abc3;\n    cursor: move;\n}\n\n.tab-option-title {\n    margin-top: 5px;\n    margin-bottom: 15px;\n    color: #3a3535;\n    font-size: 14px;\n    text-align: center;\n    padding: 0px 10px;\n}\n\n.tab-option-title::first-letter {\n    text-transform: uppercase;\n}\n\n.promize-tab-options {\n    display: flex;\n    flex-wrap: wrap;\n    /* padding: 15px 15px; */\n}\n\n.promize-widget-body .promize-tab-options {\n    padding: 0;\n}\n\n.promize-tab-option-header {\n    display: flex;\n    flex-direction: column;\n}\n\n.portlet-menu .btn {\n    min-width: auto;\n    color: #4c4646;\n    padding: 0px 10px;\n    width: 100%;\n    border-radius: 0;\n    text-align: center;\n    font-size: 12px;\n    border: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    font-weight: normal;\n    line-height: 25px;\n}\n\n.promize-tab-options .btn i.fa-ellipsis-v {\n    transform: rotate(90deg);\n    color: #495057;\n}\n\n.option-name span {\n    word-break: break-word;\n}\n\n.portlet-dropdown-menu {\n    display: block;\n    padding: 12px 0px 10px;\n    /* position: absolute;\n    width: 110px;\n    display: none;\n    right: 5px;\n    top: 37px;\n    z-index: 1;\n    background-color: #fff;\n    border-radius: 4px;\n    -webkit-box-shadow: 0px 0px 25px 0px rgba(82, 63, 105, 0.25);\n    box-shadow: 0px 0px 25px 0px rgba(82, 63, 105, 0.25); */\n}\n\n.portlet-dropdown-menu.hide {\n    display: block;\n}\n\n/* .portlet-dropdown-menu.hide {\n    display: none;\n}\n\n.portlet-dropdown-menu.show {\n    display: block;\n} */\n\n.portlet-menu {\n    display: flex;\n    justify-content: center;\n}\n\n\n.pormize-portlet-dropdown {\n    position: relative;\n    box-shadow: 0 -2px 10px rgba(82, 63, 105, .1);\n}\n\n.button-dropdown {\n    min-width: auto;\n    width: 34px;\n}\n\n.promize-tab-option-header .btn.button-dropdown {\n    display: none;\n}\n\n.portlet-menu .btn i {\n    font-size: 13px;\n}\n\n.portlet-menu .btn:hover {\n    background-color: #fff;\n    box-shadow: none;\n    color: #2f89f9;\n}\n\n.text-danger {\n    color: #F44336 !important;\n}\n\n/* CheckBox Style */\n\n.promize-checkbox {\n    display: inline-block;\n    position: relative;\n    padding-left: 22px;\n    margin-bottom: 10px;\n    text-align: left;\n    cursor: pointer;\n    font-size: 14px;\n    -webkit-transition: all 0.3s ease;\n    transition: all 0.3s ease;\n}\n\n.promize-checkbox>input {\n    position: absolute;\n    z-index: -1;\n    opacity: 0;\n}\n\n.promize-checkbox>span {\n    border-radius: 2px;\n    background: none;\n    position: absolute;\n    top: 1px;\n    left: 0;\n    height: 18px;\n    width: 18px;\n    border: 2px solid #2f89f9;\n    -webkit-transition: all 0.3s ease;\n    transition: all 0.3s ease;\n}\n\n.promize-checkbox>span:after {\n    content: '';\n    position: absolute;\n    display: none;\n    top: 50%;\n    left: 50%;\n    margin-left: -3px;\n    margin-top: -7px;\n    width: 4px;\n    height: 10px;\n    border: solid #fff;\n    border-width: 0 2px 2px 0/*rtl:ignore*/\n    !important;\n    -webkit-transform: rotate(45deg)/*rtl:ignore*/\n    ;\n    transform: rotate(45deg)/*rtl:ignore*/\n    ;\n}\n.promize-checkbox>input:checked~span{\n    background-color: #2f89f9;\n}\n.promize-checkbox>input:checked~span:after {\n    display: block;\n}\n\n/* Radio button Style */\n\n.promize-radio {\n    display: inline-block;\n    position: relative;\n    padding-left: 22px;\n    text-align: left;\n    margin-bottom: 10px;\n    cursor: pointer;\n    font-size: 13px;\n    -webkit-transition: all 0.3s ease;\n    transition: all 0.3s ease;\n}\n\n.promize-radio>input {\n    position: absolute;\n    z-index: -1;\n    opacity: 0;\n}\n\n.promize-radio>.chk-span {\n    background: none;\n    position: absolute;\n    top: -1px;\n    left: 0;\n    height: 18px;\n    width: 18px;\n    border-radius: 50% !important;\n    background-color: #fff;\n    border: 1px solid #A7ABC3;\n    -webkit-transition: all 0.3s ease;\n    transition: all 0.3s ease;\n}\n\n.promize-radio>.chk-span:after {\n    content: '';\n    position: absolute;\n    display: none;\n    top: 50%;\n    left: 50%;\n    margin-left: -3px;\n    margin-top: -3px;\n    width: 6px;\n    height: 6px;\n    transition: all 0.3s ease;\n    background: #ffffff;\n    border-radius: 100% !important;\n}\n\n.inputgroup .disabled {\n    opacity: 0.4;\n    pointer-events: none;\n    cursor: not-allowed;\n}\n\n.inputgroup .disabled.checked {\n    opacity: 1;\n}\n\n.promize-radio>input:checked~.chk-span {\n    background-color: #2f89f9;\n    border-color: #2f89f9;\n}\n\n.promize-radio>input:checked~.chk-span:after {\n    display: block;\n}\n\n.widget-body .check-mainbox .inputgroup>div {\n    display: flex;\n}\n\n.widget-body .check-mainbox label+label {\n    margin-left: 6px;\n}\n\n.promize-attr-radio {\n    padding-left: 40px;\n    height: 40px;\n    border: 1px solid #D9D9D9;\n    border-radius: 5px;\n    padding-top: 9px;\n    padding-right: 10px;\n    color: #434863;\n    min-width: 150px;\n}\n\n.promize-attr-radio.checked {\n    pointer-events: none;\n}\n\n.promize-attr-radio:hover {\n    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.11);\n}\n\n.promize-attr-radio .chk-cover {\n    position: absolute;\n    left: -1px;\n    top: -1px;\n    height: 40px;\n    width: 40px;\n    background-color: #fff;\n    border: 1px solid #D9D9D9;\n    border-top-left-radius: 5px;\n    border-bottom-left-radius: 5px;\n}\n\n.promize-attr-radio>input:checked~.chk-cover {\n    background-color: #2D88F9;\n    border: 1px solid #2D88F9;\n}\n\n.promize-attr-radio .chk-span {\n    top: 10px;\n    left: 10px;\n    border: 1px solid #A7ABC3;\n}\n\n.promize-attr-radio>input:checked~.chk-span:after {\n    border-color: #fff;\n    background-color: #fff;\n}\n\n.promize-attr-radio>input:checked~.chk-span {\n    border-color: #fff;\n}\n\n.promize-attr-radio .chk-icn {\n    margin: 0px 10px;\n    font-size: 16px;\n}\n\n.promize-no-data {\n    text-align: center;\n}\n\n.promize-no-data img {\n    max-width: 200px;\n}\n\n.promize-no-data p {\n    color: #637381;\n    font-weight: bold;\n}\n\n.promize-widget-toggle {\n    justify-self: flex-end;\n}\n\n.promize-widget-toggle .btn i {\n    font-size: 20px;\n}\n\n.promize-group-upload-items {\n    display: flex;\n    flex-wrap: wrap;\n    margin: 0px -10px;\n}\n\n.promize-group-upload-items>li {\n    width: 80px;\n    height: 80px;\n    margin: 0px 10px 10px;\n    border: 1px solid #ddd;\n}\n\n.promize-uploded-image {\n    padding: 2px;\n    border-radius: 2px;\n    position: relative;\n    overflow: hidden;\n    display: flex;\n    height: 100%;\n    width: 100%;\n    justify-content: center;\n    align-items: center;\n}\n\n.promize-group-upload-items>li .promize-uploded-image img {\n    max-width: 100%;\n    max-height: 74px;\n}\n\n.promize-group-upload>p {\n    margin-bottom: 10px;\n}\n\n.promize-uploded-image .promize-upload-delete {\n    position: absolute;\n    top: 100%;\n    height: 100%;\n    width: 100%;\n    left: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    color: #fff;\n    font-size: 15px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all .3s;\n}\n\n.promize-uploded-image:hover .promize-upload-delete {\n    top: 0;\n}\n\n.promize-upload-delete i {\n    padding: 6px 7px;\n    border: 1px solid #fff;\n    border-radius: 2px;\n    cursor: pointer;\n}\n\n.btn-tbl.delete {\n    color: #f36842;\n}\n\n.promize-view-container {\n    display: flex;\n    border: 1px solid #e6e6e6;\n    border-radius: 5px;\n    position: relative;\n    overflow: hidden;\n}\n\n.promize-option-container {\n    background-color: #fff;\n    margin: 0px auto;\n    padding: 20px;\n    position: relative;\n    width: 90%;\n}\n\n.promize-option-container .canvas-container {\n    margin: 0px auto;\n    max-width: 400px;\n    height: auto !important;\n    border: 1px solid #ececec;\n    padding: 10px;\n    width: auto !important;\n    height: 300px !important;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.promize-option-container .canvas-container>canvas {\n    max-width: 100%;\n    height: auto !important;\n    position: relative !important;\n    max-height: 280px;\n    width: auto !important;\n}\n\n.promize-option-container .canvas-container>canvas:last-child {\n    position: absolute !important;\n    max-width: calc(100% - 20px);\n    margin: auto;\n    right: 0;\n    bottom: 0;\n    width: auto !important;\n    max-height: 280px;\n}\n\n.promize-opt-thumb {\n    width: 90px;\n    background: #fff;\n    margin-left: 10px;\n    margin-top: 10px;\n    font-size: 12px;\n}\n\n.promize-stp-options {\n    position: absolute;\n    top: 20px;\n    right: 40px;\n    display: flex;\n    flex-direction: column;\n}\n.promize-stp-options .btn-promize-secondary{\n margin: 0;\n}\n.promize-stp-options .btn-promize-secondary+.btn-promize-secondary{\n    margin-top: 10px;\n}\n.thumb-itm {\n    border: 1px solid #ddd;\n    padding: 10px;\n    opacity: 0.5;\n    cursor: pointer;\n}\n.thumb-itm+.thumb-itm{\n    margin-top: 10px;\n}\n.thumb-itm.current-item {\n    border: 1px solid #2F89F9;\n    cursor: default;\n    opacity: 1;\n}\n.thumb-itm img {\n    max-width: 50px;\n    max-height: 50px;\n}\n\n.promize-set-position .promize-slide-icon {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    font-size: 30px;\n    color: #9A9A9A;\n    font-weight: 100;\n    padding: 2px 10px;\n    cursor: pointer;\n}\n\n.sub-tab-content {\n    position: relative;\n    margin-left: 40px;\n}\n\n.sub-tab-content:before {\n    content: \"\";\n    position: absolute;\n    left: -25px;\n    top: -10px;\n    height: calc(100% - 15px);\n    width: 22px;\n    border: 1px dashed #707070;\n    border-top: 0;\n    border-right: 0;\n}\n\n.sub-tab-content+.sub-tab-content:before {\n    top: -45px;\n    height: calc(100% + 20px);\n}\n\n.promize-clipart-options {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.promize-clipart-options>li {\n    margin-right: 10px;\n    margin-bottom: 10px;\n}\n\n.promize-clipart-thumb {\n    text-align: center;\n    font-size: 14px;\n    padding: 5px 10px;\n    border: 1px solid #e8e8e8;\n    border-radius: 5px;\n}\n\n.promize-clipart-thumb img {\n    max-width: 60px;\n    max-height: 60px;\n}\n\n.promize-slide-icon.promize-canvas-prev-btn {\n    left: 20px;\n}\n\n.promize-slide-icon.promize-canvas-next-btn {\n    right: 10px;\n}\n\n.promize-set-position input[type=number]::-webkit-inner-spin-button, .promize-set-position input[type=number]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n}\n\n.promize-canvas-hw {\n    position: relative;\n}\n\n.promize-canvas-hw .prop-lock-hw {\n    position: absolute;\n    right: -45px;\n    top: 53%;\n    transform: translateY(-50%);\n}\n\n.btn-prop-lock {\n    font-size: 12px;\n    padding: 6px 8px;\n    border: 1px solid #D9D9D9;\n    color: #D9D9D9;\n    border-radius: 3px;\n    cursor: pointer;\n    transition: all .3s;\n    background-color: #fff;\n}\n\n.promize-set-position .promize-form-group {\n    margin-bottom: 10px;\n}\n\n.promize-set-position .promize-form-group label {\n    color: #202646;\n    font-weight: bold;\n    font-size: 11px;\n}\n\n.promize-slider-dot-items li {\n    background-color: #D1D1D1;\n    height: 10px;\n    width: 10px;\n    border-radius: 6px;\n    cursor: pointer;\n}\n\n\n\n.promize-slider-dot-items li+li {\n    margin-left: 10px;\n}\n\n.promize-image-collection {\n    margin-left: auto;\n    margin-right: auto;\n    padding: 10px 15px;\n    margin-top: 10px;\n    background-color: #fff;\n    border: 1px solid #757575;\n    border-radius: 3px;\n}\n\n.promize-coll-images-items {\n    border: 1px solid #e8e8e8;\n    background-color: #fff;\n    padding: 5px;\n    text-align: center;\n    border-radius: 3px;\n    cursor: pointer;\n    margin-right: 20px;\n    margin-bottom: 20px;\n}\n\n.promize-coll-images-items>img {\n    max-width: 70px;\n    max-height: 70px;\n}\n\n.promize-img-coll-detail {\n    padding-right: 20px;\n    margin-right: 20px;\n    border-right: 1px solid #C5C5C5;\n    text-align: right;\n    font-family: \"Lato\";\n}\n\n.promize-img-coll-title {\n    color: #202646;\n    font-size: 15px;\n}\n\n.promize-img-coll-subtitle {\n    font-size: 12px;\n    color: #b5b5b5;\n}\n\n.promize-coll-images-items.disabled {\n    opacity: .4;\n    cursor: not-allowed;\n}\n\n.promize-slide-icon.disabled {\n    opacity: .2;\n    cursor: default;\n    pointer-events: none;\n}\n\n.btn-prop-lock.locked {\n    color: #fff;\n    border: 1px solid #202646;\n    background-color: #202646;\n}\n\n.promize-milist {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.promize-milist>li>img {\n    max-width: 40px;\n    max-height: 40px;\n}\n\n.promize-milist>li {\n    margin-right: 5px;\n    padding: 2px;\n    border: 1px solid #ddd;\n    display: flex;\n    align-items: center;\n}\n\n.promize-tbl-img-sm {\n    max-width: 40px;\n    max-height: 40px;\n}\n\n.promize-card-setting {\n    background-color: #fff;\n    padding: 25px;\n    border-radius: 5px;\n    margin-right: 20px;\n    margin-bottom: 20px;\n    cursor: pointer;\n    -webkit-box-shadow: 0 0 13px 0 rgba(82, 63, 105, .05);\n    box-shadow: 0 0 13px 0 rgba(82, 63, 105, .05);\n    transition: all .3s;\n}\n\n.promize-card-setting:hover {\n    -webkit-box-shadow: 0 0 13px 0 rgba(82, 63, 105, .05);\n    box-shadow: 0 10px 13px 0 rgba(82, 63, 105, .2);\n}\n\n.promize-settings-icon {\n    height: 50px;\n    width: 50px;\n    margin: auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 25px;\n    margin-bottom: 20px;\n}\n\na {\n    text-decoration: none;\n}\n\n.promize-settings-icon i {\n    font-size: 22px;\n}\n\n.bg-lg-bl {\n    background-color: rgba(45, 136, 249, 0.1);\n}\n\n.clr-bl {\n    color: #2D88F9;\n}\n\n.clr-org {\n    color: #FF8969;\n}\n\n.bg-lg-gr {\n    background-color: rgba(74, 143, 0, 0.1);\n}\n\n.clr-gr {\n    color: #4B8F00;\n}\n\n.bg-lg-rd {\n    background-color: rgba(206, 25, 73, 0.1)\n}\n\n.clr-rd {\n    color: #CE1949;\n}\n\n.bg-lg-yl {\n    background-color: rgba(252, 189, 89, 0.1)\n}\n\n.clr-yl {\n    color: #FCBD59;\n}\n\n.promize-settings-header {\n    color: #011838;\n    font-size: 15px;\n    font-weight: bold;\n    margin-bottom: 15px;\n}\n\n.promize-settings-desc {\n    font-size: 14px;\n    color: #989BAD;\n}\n\n.promize-prdt-section-conatiner>ul {\n    border-bottom: 1px solid #D0D0D0;\n}\n\n.promize-prdt-section-list>li.active:after {\n    position: absolute;\n    content: \"\";\n    height: 4px;\n    width: 100%;\n    left: 0;\n    bottom: -1px;\n    background-color: #2f89f9;\n    border-top-left-radius: 4px;\n    border-top-right-radius: 4px;\n}\n\n.promize-prdt-section-list>li {\n    position: relative;\n    display: inline-block;\n    padding: 10px 15px;\n    height: 40px;\n    font-size: 15px;\n    color: #7d8196;\n    transition: all .2s;\n}\n\n.promize-prdt-section-list>li.active {\n    color: #011838;\n}\n\n.promize-section-name .promize-section-status {\n    height: 8px;\n    width: 8px;\n    display: inline-block;\n    margin-right: 6px;\n    border-radius: 4px;\n}\n\n.promize-section-name {\n    cursor: pointer;\n    white-space: nowrap;\n    display: flex;\n    flex-direction: row-reverse;\n    align-items: center;\n}\n\n.promize-section-name span {\n    white-space: nowrap;\n}\n\n.promize-section-name .edit-icon {\n    border-radius: 3px;\n    visibility: hidden;\n    position: absolute;\n    right: -8px;\n    bottom: 6px;\n    padding: 4px 0px;\n    background-color: transparent;\n    border: 1px solid transparent;\n    font-size: 13px;\n    height: 26px;\n    width: 18px;\n    text-align: center;\n    color: #676464;\n    cursor: pointer;\n    transform: translateX(-15px);\n    opacity: 0;\n    transition: all .3s;\n}\n.promize-prdt-section-list>li:hover {\n    color: #464242;\n}\n.promize-prdt-section-list>li:hover .edit-icon {\n    transform: translateX(0);\n    opacity: 1;\n    visibility: visible;\n}\n\n.promize-section-status.active {\n    background-color: #20CE09;\n}\n\n.promize-section-status.in-active {\n    background-color: #FF8969;\n}\n\n.btn-rnd {\n    color: #6b6e82;\n    border: 1px solid #6b6e82;\n    height: 30px;\n    line-height: 30px;\n    border-radius: 15px;\n    padding: 0px 15px;\n    font-size: 12px;\n    background-color: #f2f3f8;\n}\n\n.pormize-abs-rght {\n    position: absolute;\n    right: 0;\n    top: 0px;\n}\n\n.promize-card-edit {\n    position: absolute;\n    width: 300px;\n    z-index: 1;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.4);\n    border-radius: 3px;\n}\n\n.promize-prdt-section-conatiner {\n    position: relative;\n}\n\n.promize-configure-wrapper {\n    display: flex;\n    height: 100vh;\n}\n\n.promize-overlay-container {\n    width: 62%;\n    background: url('../images/background.png') rgba(1, 24, 56, 0.8);\n    padding-left: 50px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    background-blend-mode: multiply;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 100%;\n}\n\n.promize-config-form {\n    width: 38%;\n    background-color: #011838;\n    padding: 0px 60px;\n}\n\n.promize-logo-sm>img {\n    max-width: 100px;\n}\n\n.promize-logo-sm {\n    text-align: center;\n    margin-top: 100px;\n    margin-bottom: 40px;\n}\n\n.promize-form-title {\n    color: #fff;\n    font-size: 25px;\n    text-align: center;\n    margin: 20px 0px;\n    font-weight: normal;\n}\n\n.promize-config-form .promize-form-control {\n    height: 46px;\n    background-color: transparent;\n    border-color: rgba(255, 255, 255, 0.6);\n    color: rgba(255, 255, 255, 0.6);\n}\n.promize-config-form .promize-form-control:focus {\n    border-color: #2f89f9;\n}\n.promize-config-form .promize-form-control-label {\n    font-size: 16px;\n    margin-bottom: 10px;\n    color: rgba(255, 255, 255, 0.6);\n}\n\n.promize-config-form .promize-form-group {\n    margin-bottom: 40px;\n}\n\n.promize-config-form .btn-promize-primary {\n    width: 100%;\n    height: 46px;\n    font-size: 20px;\n    font-weight: normal;\n}\n.promize-config-form .btn-promize-primary:hover {\n    border: 1px solid #076cec;\n    background-color: #076cec;\n}\n.promize-config-form p {\n    text-align: center;\n    margin-top: 60px;\n    font-size: 16px;\n    color: rgba(255, 255, 255, 0.6);\n}\n\n.promize-configure-wrapper a {\n    color: #3089fa;\n}\n\n.promize-logo-lg {\n    margin-top: 50px;\n}\n\n.promize-work {\n    margin-bottom: 50px;\n}\n\n.promize-key-value {\n    color: #fff;\n}\n\n.promize-key-value .promize-secondary-title {\n    font-size: 30px;\n    font-weight: normal;\n}\n\n.promize-key-value .promize-primary-title {\n    font-size: 40px;\n    font-weight: bold;\n}\n\n.promize-highlight-text {\n    border-bottom: 5px solid #3089fa;\n    padding-bottom: 5px;\n}\n\n.promize-attribute-options>div {\n    color: #434863;\n    font-size: 13px;\n}\n.promize-attr-content {\n    display: flex;\n    align-items: flex-start;\n}\n.promize-attr-option-title {\n    min-width: 160px;\n    display: flex;\n    justify-content: space-between;\n}\n.promize-attr-option-value {\n    margin-left: 10px;\n}\n.promize-attr-option-value>span{\n    margin-right: 10px;\n    margin-bottom: 5px;\n}\n.promize-attribute-options>div:not(:last-child) {\n\n}\n\n.promize-attribute-options>div>span {\n    display: inline-block;\n}\n\n.promize-attribute-options>div>span:first-child {\n    width: 160px;\n}\n\n.promize-attribute-options>div>span:nth-child(2) {\n    width: 30px;\n    text-align: left;\n}\n\n.promize-attribute-options>div>span:last-child {\n    font-weight: bold;\n    font-size: 13px;\n}\n\n.promize-work a {\n    position: relative;\n    padding-left: 50px;\n    color: #fff;\n}\n\n.promize-work a i {\n    position: absolute;\n    left: 16px;\n    top: 3px;\n    color: #fff;\n    font-size: 12px;\n}\n\n.promize-work a:before {\n    content: \"\";\n    position: absolute;\n    height: 40px;\n    width: 40px;\n    left: 0;\n    top: -12px;\n    background-color: #3089fa;\n    border-radius: 20px;\n}\n\n.promize-popup {\n    position: fixed;\n    width: 100%;\n    left: 0;\n    right: 0;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.6);\n    text-align: center;\n    padding-top: 100px;\n}\n\n.promize-popup-inner {\n    position: relative;\n    box-shadow: 0 0px 15px black;\n    display: inline-block;\n}\n\n.popup-close {\n    position: absolute;\n    top: -16px;\n    right: -16px;\n    height: 36px;\n    width: 36px;\n    border-radius: 18px;\n    font-size: 16px;\n    background-color: #fff;\n    color: #000000;\n}\n\n/* fade in componets */\n\n.fade-in-section {\n    opacity: 0;\n    transform: translateY(20vh);\n    visibility: hidden;\n    transition: opacity 1200ms ease-out, transform 600ms ease-out, visibility 1200ms ease-out;\n    will-change: opacity, transform, visibility;\n}\n\n.fade-in-section.is-visible {\n    opacity: 1;\n    transform: none;\n    visibility: visible;\n}\n\n.promize-dashboard>img {\n    width: 100%;\n    height: auto;\n}\n\n.promize-dashboard {\n    margin-top: 20px;\n}\n\n.promize-coming-soon>img {\n    max-width: 500px;\n    margin-top: 100px;\n}\n\n.promize-coming-soon {\n    text-align: center;\n}\n\n.promize-text-options {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.promize-text-highlight-aa {\n    padding: 3px 8px;\n    background-color: #efefef;\n    border-radius: 3px;\n    font-size: 12px;\n    margin-bottom: 4px;\n    margin-right: 3px;\n}\n\n.promize-text-options>li {\n    margin-bottom: 4px;\n    margin-right: 3px;\n}\n\n.css-2b097c-container:focus {\n    outline: 0;\n}\n\n.css-yk16xz-control {\n    border-color: #D9D9D9;\n}\n\n.css-1pahdxg-control:hover {\n    box-shadow: none;\n}\n\n.css-1rhbuit-multiValue {\n    background-color: hsl(213, 94%, 58%);\n}\n\n.css-12jo7m5 {\n    color: #fff;\n}\n\n.css-1alnv5e {\n    cursor: pointer;\n}\n\n.css-1rhbuit-multiValue .css-tj5bde-Svg {\n    fill: #f1f1f1;\n}\n\n.promize-rule-container .promize-widget {\n    border: 1px solid #A7ABC3;\n    border-radius: 0;\n}\n.promize-rule-container .promize-widget-title\n{\n    padding-right: 50px;\n}\n.promize-rule-container>.promize-widget.collapse {\n    max-height: 50px;\n    overflow: hidden;\n    transition: max-height .5s;\n}\n.promize-rule-container>.promize-widget.collapse.open {\n    max-height: 1500px;\n    transition: max-height .5s;\n}\n.promize-rule-container .promize-widget-toggle {\n    margin-left: auto;\n}\n.promize-rule-container .promize-widget.open .promize-widget-toggle.btn\n{\n    transform: rotate(90deg);\n}\n.promize-rule-container .promize-widget-body {\n    border: 0;\n}\n\n.promize-widget-title .edit-icon {\n    border-radius: 3px;\n    display: none;\n    position: absolute;\n    right: calc(-25px + 50px);\n    bottom: 3px;\n    padding: 4px 0px;\n    background-color: transparent;\n    border: 1px solid transparent;\n    font-size: 13px;\n    height: 26px;\n    width: 18px;\n    text-align: center;\n    color: #9e9e9e;\n    cursor: pointer;\n    transition: all .3s;\n}\n\n.promize-widget-title:hover>.edit-icon {\n    display: block;\n}\n\n\n.promize-widget-title {\n    position: relative;\n}\n\n.rule-block {\n    position: relative;\n}\n.promize-rule-container .promize-form-group{\n    margin-bottom: 15px;\n}\n.rule-condition .promize-form-group {\n    margin: 0px 5px;\n}\n.rule-condition .promize-form-control {\n    height: 30px;\n    width: 80px;\n}\n.rule-block:before {\n    position: absolute;\n    content: \"\";\n    width: 15px;\n    height: 50px;\n    border: 1px dashed #6d6d6d;\n    border-top: 0px;\n    border-right: 0px;\n    top: 33px;\n    left: 3px;\n}\n\n.promize-rule-container .btn-rule-condition {\n    background-color: transparent;\n    margin-left: 5px;\n    width: auto;\n    font-size: 14px;\n    margin-left: 0px;\n    padding: 0px 0px;\n    min-width: 30px;\n    border-radius: 0;\n    border: 0;\n    font-weight: normal;\n    color: #A7ABC3;\n    border-radius: 16px;\n    position: relative;\n    margin-top: 10px;\n}\n.promize-rule-container .promize-form-control\n{\n    font-size: 13px;\n}\n\n/* .promize-condition-list .rule-condition-item+.rule-condition-item:before {\n    position: absolute;\n    content: \"\";\n    width: 20px;\n    height: 86px;\n    border: 1px dashed #6d6d6d;\n    border-right: 0px;\n    bottom: 44px;\n    left: -20px;\n}\n.promize-condition-list .rule-condition-item+.rule-condition-item:after {\n    position: absolute;\n    content: \"+\";\n    width: 20px;\n    height: 20px;\n    border: 1px solid #6d6d6d;\n    bottom: 78px;\n    left: -30px;\n    font-size: 16px;\n    text-align: center;\n    font-weight: bold;\n    background-color: #f2f3f8;\n    border-radius: 15px;\n} */\n\n.rule-condition-item {\n    position: relative;\n}\n.promize-rule-action {\n    position: relative;\n}\n\n.promize-rule-action:before {\n    position: absolute;\n    content: \"\";\n    width: 15px;\n    height: 55px;\n    border: 1px dashed #6d6d6d;\n    border-top: 0px;\n    border-right: 0px;\n    top: -20px;\n    left: 15px;\n}\n\n.promize-rule-container .promize-widget .btn-promize-primary,.promize-rule-container .promize-widget .btn-promize-secondary {\n    height: 40px;\n    line-height: normal;\n    min-width: 90px;\n}\n.promize-rule-container .promize-widget-header\n{\n    padding: 7px 15px;\n    min-height: 50px;\n}\n.promize-title-edit {\n    display: flex;\n    align-items: center;\n}\n\n.promize-title-edit .promize-form-control {\n    height: 36px;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n    border-right: 0;\n}\n\n.promize-title-edit-save {\n    height: 36px;\n    width: 36px;\n    background-color: #fff;\n    color: #4B8F00;\n    border: 1px solid #d9d9d9;\n    border-top-right-radius: 3px;\n    border-bottom-right-radius: 3px;\n}\n\n.promize-title-edit .promize-form-group>label:empty {\n    display: none;\n}\n\n.promize-title-edit .promize-form-group {\n    margin: 0;\n}\n.promize-option-titl-list {\n    display: flex;\n    justify-content: space-between;\n}\n.promize-option-content+.promize-option-content {\n    margin-top: 10px;\n}\n\n.promize-option-content-list {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-radius: 5px;\n    border: 0;\n    background-color: #fff;\n    box-shadow: 0 0 13px rgba(82, 63, 105, 0.10);\n    padding: 8px 5px;\n}\n.promize-option-content-list .promize-form-group {\n    margin: 0;\n}\n\n.promize-option-content-list .promize-form-control {\n    height: 32px;\n    font-size: 12px;\n}\n.promize-option-titl-list>div {\n    width: 10%;\n    font-size: 12px;\n    padding: 5px 3px;\n}\n\n.promize-option-content-list>div {\n    width: 10%;\n    font-size: 12px;\n}\n\n.promize-option-titl-list>div:last-child {\n    width: 80px;\n}\n\n.promize-option-content-list>div:last-child button+button {\n    margin-left: 3px;\n}\n\n.promize-option-content-list>div:last-child {\n    width: 85px;\n}\n.promize-option-titl-list>div:nth-child(2),.promize-option-content-list>div:nth-child(2) {\n    width: 10%;\n}\n.promize-option-titl-list>div:nth-child(3),.promize-option-content-list>div:nth-child(3) {\n    width: 10%;\n}\n.promize-option-titl-list>div:nth-child(4),.promize-option-content-list>div:nth-child(4) {\n    width: 10%;\n}\n.promize-option-titl-list>div:nth-child(5),.promize-option-content-list>div:nth-child(5) {\n    width: 10%;\n}\n.promize-option-titl-list>div:nth-child(6),.promize-option-content-list>div:nth-child(6) {\n    width: 10%;\n}\n.promize-option-titl-list>div:nth-child(7),.promize-option-content-list>div:nth-child(7) {\n    width: 10%;\n}\n.promize-option-titl-list>div:nth-child(8),.promize-option-content-list>div:nth-child(8) {\n    width: 10%;\n}\n.promize-option-content-list>div:not(:first-child) {\n    padding: 0px 5px;\n}\n/* General Settings */\n.promize-general-settings .promize-card-title h3 span {\n    font-size: 20px;\n}\n.promize-general-settings {\n    margin-bottom: 30px;\n}\n\n.promize-general-settings .promize-card-title h3 {\n    margin: 0;\n}\n\n.promize-questions>p {\n    margin-top: 10px;\n    color: #011837;\n}\n\n\n.promize-general-settings .promize-radio, .promize-general-settings .promize-checkbox {\n    display: block;\n    font-size: 13px;\n}\n\n.promize-general-settings .promize-checkbox {\n    padding-top: 4px;\n    padding-bottom: 5px;\n}\n\n.ques-container {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    margin-bottom: 10px;\n    padding: 8px 5px;\n    transition: all .3s;\n}\n\n.promize-ques {\n    margin-top: 5px;\n}\n\n.ques-container:hover {\n    background-color: #f1f1f1;\n}\n.ques-container .check-mainbox{\n    width: 100%;\n    margin-left: 20px;\n}\n.ques-container .check-mainbox:nth-of-type(1n):last-child {\n      width: unset;\n}\n\n.input-range__label--value{\n    display: none;\n}\n\n/* React select  */\n.css-4ljt47-MenuList {\n    max-height: 130px;\n}\n\n/* 3D product Design */\n\n.promize-3d-parts-list {\n    margin-top: 20px;\n}\n.promize-3d-parts-list>li {\n    display: inline-block;\n    padding: 5px 15px;\n    height: 25px;\n    background-color: rgba(98, 153, 221, 0.1);\n    color: #6299dd;\n    margin-right: 5px;\n    margin-bottom: 5px;\n    border-radius: 15px;\n    font-size: 12px;\n}\n\n.pz-intro-cover * {\n    box-sizing: border-box;\n    font-family: 'Lato', sans-serif;\n}\n\n.pz-intro-cover {\n    position: fixed;\n    height: 100%;\n    width: 100%;\n    left: 0;\n    right: 0;\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    display: none;\n}\n\n.pz-intro {\n    max-width: 700px;\n    height: 420px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 20px;\n    border: 1px solid #999;\n    background-color: #fff;\n}\n\n.pz-intro-title {\n    text-align: center;\n    font-size: 45px;\n    margin-bottom: 30px;\n}\n\n.pz-intro-text {\n    font-size: 20px;\n    text-align: center;\n    margin-bottom: 70px;\n}\n\n.pz-intro-proceed {\n    text-align: center;\n}\n\n.pz-lets-start-btn {\n    height: 50px;\n    font-size: 18px;\n    padding: 5px 30px;\n    border: 1px solid #3b91fa;\n    background-color: #3b91fa;\n    color: #fff;\n    cursor: pointer;\n    transition: all .3s;\n}\n\n.pz-lets-start-btn:hover {\n    background-color: #0d2250;\n    border-color: #0d2250;\n}\n/*\n\n.promize-highlight-v1 {\n    background-color: rgba(59, 145, 250, 0.2);\n    padding: 2px 5px;\n    border-radius: 5px;\n    color: #0c55af;\n    font-weight: 400;\n    font-size: 13px;\n}\n.ul-style-disc\n{\n    list-style-type: disc;\n}\n.ul-style-circle\n{\n    list-style-type: circle;\n}\n.img-responsive\n{\n    max-width: 100%;\n}\n*/\n\n/*************USER GUID CSS *****************/\n\n.promize-highlight-v1 {\n    background-color: rgba(59, 145, 250, 0.2);\n    padding: 5px 14px 6px;\n    border-radius: 5px;\n    color: #0c55af;\n    font-size: 16px;\n    font-weight: bold;\n}\n\n.ul-style-disc {\n    list-style-type: disc;\n}\n\n.ul-style-circle {\n    list-style-type: circle;\n}\n\n.img-responsive {\n    max-width: 100%;\n}\n\n.pz-user-guide-content p {\n    line-height: 1.5;\n}\n\n.pz-user-guide-cover {\n    width: 250px;\n    flex: 250px 0 0;\n    align-self: flex-start;\n    position: -webkit-sticky;\n    position: sticky;\n    top: 50px;\n    border-right: 1px dashed #949494;\n    padding-bottom: 50px;\n    padding-right: 15px;\n}\n\n.pz-user-guide-menu-list>li {\n    margin-bottom: 20px;\n    display: flex;\n    align-items: center;\n    position: relative;\n    transition: all .2s;\n}\n\n.pz-user-guide-menu-list>li>a {\n    width: 100%;\n    height: 100%;\n    padding: 8px 0px;\n    color: #6d747c;\n    line-height: 1.8;\n    padding-left: 10px;\n    border: 0;\n}\n.pz-user-guide-menu-list>li>a:focus, .pz-user-guide-menu-list>li>a:active {\n    border: 0;\n    outline: 0;\n}\n.pz-user-guide-menu-list>li.active:before {\n    content: \"\";\n    position: absolute;\n    height: 100%;\n    width: 4px;\n    background-color: #1c2160;\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n}\n\n.pz-user-guide-menu-list>li:hover {\n    background-color: #f2f3f8;\n}\n.pz-user-guide-content p,.pz-user-guide-content li{\n    line-height: 1.8;\n}\n.user-guide-title\n{\n    font-size: 25px;\n}\n\n\nxmp {\n    font-size: 12px;\n    margin-top: 0;\n    max-width: 100%;\n    overflow-x: auto;\n}\n/* *************** */\n\n\n\n/* Media Queris */\n\n@media only screen and (max-width: 1399px) {\n    .promize-modal.modal-lg {\n        max-width: 85%;\n    }\n    .promize-logo-sm>img {\n        max-width: 80px;\n    }\n    .promize-form-title {\n        font-size: 20px;\n    }\n    .promize-logo-sm {\n        margin-bottom: 30px;\n        margin-top: 80px;\n    }\n    .promize-config-form .promize-form-control {\n        height: 38px;\n    }\n    .promize-config-form .btn-promize-primary {\n        height: 38px;\n        font-size: 16px;\n        margin-top: 20px;\n    }\n    .promize-config-form .promize-form-group {\n        margin-bottom: 25px;\n    }\n    .promize-config-form p {\n        margin-top: 40px;\n    }\n    .promize-table tbody tr td\n    {\n        padding: 6px 10px;\n        font-size: 13px;\n    }\n}\n\n.wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100vh;\n}\n\n.preloader {\n    display: block;\n    width: 200px;\n    height: 200px;\n    border-radius: 50%;\n    border: 5px solid transparent;\n    border-top-color: #3089f9;\n    position: relative;\n    animation: rotating 2.5s infinite ease;\n    -webkit-animation: rotating 2.5s infinite linear;\n}\n\n.preloader:after, .preloader:before {\n    content: \"\";\n    position: absolute;\n    border-radius: inherit;\n    border: inherit;\n}\n\n.preloader:after {\n    top: 5px;\n    left: 5px;\n    width: 180px;\n    height: 180px;\n    border-top-color: #f89f11;\n    animation: rotating 2s infinite ease;\n    -webkit-animation: rotating 2s infinite linear;\n}\n\n.preloader:before {\n    top: 15px;\n    left: 15px;\n    width: 160px;\n    height: 160px;\n    border-top-color: #fa4978;\n    animation: rotating 1.5s infinite ease;\n    -webkit-animation: rotating 1.5s infinite linear;\n}\n\n\n.wrapperopacity {\n    left: 0;\n    top :0;\n    z-index: 1;\n    position:fixed;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100vh;\n}\n\n.wrapperopacity:after {\n    content: '';\n    background: #000000;\n    opacity: 0.3;\n    position: fixed;\n    width: 100%;\n    height: 100vh;\n}\n\n.preloaderopacity {\n    display: block;\n    width: 200px;\n    height: 200px;\n    border-radius: 50%;\n    border: 5px solid transparent;\n    border-top-color: #3089f9;\n    position: relative;\n    animation: rotating 2.5s infinite ease;\n    -webkit-animation: rotating 2.5s infinite linear;\n}\n\n.preloaderopacity:after, .preloaderopacity:before {\n    content: \"\";\n    position: absolute;\n    border-radius: inherit;\n    border: inherit;\n}\n\n.preloaderopacity:after {\n    top: 5px;\n    left: 5px;\n    width: 180px;\n    height: 180px;\n    border-top-color: #f89f11;\n    animation: rotating 2s infinite ease;\n    -webkit-animation: rotating 2s infinite linear;\n}\n\n.preloaderopacity:before {\n    top: 15px;\n    left: 15px;\n    width: 160px;\n    height: 160px;\n    border-top-color: #fa4978;\n    animation: rotating 1.5s infinite ease;\n    -webkit-animation: rotating 1.5s infinite linear;\n}\n\n\n@keyframes rotating {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n@-webkit-keyframes rotating {\n    0% {\n        transform: rotate(0deg);\n        -webkit-transform: rotate(0deg);\n        -ms-transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n        -webkit-transform: rotate(0deg);\n        -ms-transform: rotate(0deg);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
